import React, { useState, useEffect, useRef, useContext } from "react";
import {Modal, Button, Form, Row, Col, Spinner, Dropdown, Container, Card, Table} from "react-bootstrap";
import {
    adminResolveBookDuplicate,
    checkMarketplaceAvailabilityApi,
    fetchAssignmentsAdmin,
    fetchUserDataById,
    getBookDataUrlApi,
    getFullBookDataUrlApi,
    updateBook,
    updateBookAdmin
} from "../../http/bookAPI";
import { toast } from "react-toastify";
import { Context } from "../../index";
import { observer } from "mobx-react-lite";
import AvatarEditor from 'react-avatar-editor';
import {getRedirectUrlApi, updateUserDataAdminFront, userBalanceChangeApi} from "../../http/userAPI";
import {fetchUserLogs, fetchUserLogsBA, getLinkedByUserApi} from "../../http/userLogAPI";
import DownloadProgressModal from "../modals/DownloadProgressModal";
import {downloadWithProgress} from "../../helpers/downloadWithProgress";
import {toDate} from "date-fns";
import {flushSync} from "react-dom";

const EditBookAdmin = observer(({
    show,
    handleClose,
    bookData,
    duplicateInfo,
    onUpdate,
    onOpenUserBooks,
    onOpenBookAssignments,
    onOpenUserAuthorAssignments,
    onOpenUserReviewerAssignments,
}) => {
    const { book } = useContext(Context);
    const [pdffile, setPdfFile] = useState(null)
    const [titleState, setTitleState] = useState('');
    const [subtitleState, setSubTitleState] = useState('');
    const [authorState, setAuthorState] = useState('');
    const [summaryState, setSummaryState] = useState('');
    const [coverPreview, setCoverPreview] = useState(null);
    const [coverFileState, setCoverFileState] = useState(null);
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState("");

    const [showEditor, setShowEditor] = useState(false); // Управление отображением редактора
    const [scale, setScale] = useState(1);
    const [editorRef, setEditorRef] = useState(null);
    const [editorSize, setEditorSize] = useState({ width: 272, height: 410 });
    const [bookFormat, setBookFormat] = useState("6x9");
    const [originalCover, setOriginalCover] = useState(null);

    const [paperbackAsinState, setPaperBackAsinState] = useState('');
    const [kindleAsinState, setKindleAsinState] = useState('');
    const [hardcoverAsinState, setHardCoverAsinState] = useState('');
    const [audioAsinState, setAudioAsinState] = useState('');
    const [audibleAsinState, setAudibleAsinState] = useState('');
    const [audioBookLinkState, setAudioBookLinkState] = useState('');
    const [kindlePriceState, setKindlePriceState] = useState('');
    const [paperbackPriceState, setPaperbackPriceState] = useState('');
    const [hardcoverPriceState, setHardcoverPriceState] = useState('');
    const [coverImageUrlFromAmazon, setCoverImageUrlFromAmazon] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [fullGrabbedData, setFullGrabbedData] = useState(null);

    const [grabAttempts, setGrabAttempts] = useState(0);
    const [noManuscript, setNoManuscript] = useState(
        (bookData?.book_download || '').toUpperCase() === 'NO_MANUSCRIPT'
    );
    const [tempPDFFile, setTempPDFFile] = useState('');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [pdfFileTitle, setPdfFileTitle] = useState("");
    const [downloadModal, setDownloadModal] = useState({ show: false, progress: 0, status: "" });
    const hasManuscriptFile = Boolean(
        bookData?.book_download &&
        String(bookData.book_download).toUpperCase() !== "NO_MANUSCRIPT"
    );
    const formatManuscriptSize = (bytes) => {
        const value = Number(bytes);
        if (!Number.isFinite(value) || value <= 0) return "";
        return `Size: ${(value / 1024 / 1024).toFixed(2)} MB`;
    };
    const manuscriptSizeBytes =
        bookData?.book_file_display_size_bytes ||
        bookData?.book_file_processed_size_bytes ||
        bookData?.book_file_size_bytes ||
        bookData?.book_file_original_size_bytes;
    const manuscriptSizeLabel = hasManuscriptFile
        ? (formatManuscriptSize(manuscriptSizeBytes) || "Size: unknown")
        : "No manuscript";
    const parentRef = useRef(null);
    const [selectedWordCount, setSelectedWordCount ] = useState(null);
    const wordCountOptions = [
        { id: 1, count: 1000, price: 500, label: "About 1,000" },
        { id: 2, count: 5000, price: 530, label: "About 5,000" },
        { id: 3, count: 10000, price: 550, label: "About 10,000" },
        { id: 4, count: 15000, price: 600, label: "About 15,000" },
        { id: 5, count: 20000, price: 650, label: "About 20,000" },
        { id: 6, count: 25000, price: 700, label: "About 25,000" },
        { id: 7, count: 30000, price: 750, label: "About 30,000" },
        { id: 8, count: 35000, price: 800, label: "About 35,000" },
        { id: 9, count: 40000, price: 830, label: "About 40,000" },
        { id: 10, count: 45000, price: 850, label: "About 45,000" },
        { id: 11, count: 50000, price: 880, label: "About 50,000" },
        { id: 12, count: 60000, price: 900, label: "About 60,000" },
        { id: 13, count: 75000, price: 950, label: "About 75,000" },
        { id: 14, count: 85000, price: 980, label: "About 85,000" },
        { id: 15, count: 100000, price: 1100, label: "About 100,000" },
        { id: 16, count: 120000, price: 1200, label: "More then 120,000" },

    ];
    const [editAdminBook, setEditAdminBook] = useState({
        paper_back_flag: false,
        kindle_flag: false,
        kindle_unlimited_flag: false,
        hard_cover_flag: false,
        audio_flag: false,
        audio_exclusive_flag: false,
        audio_non_exclusive_flag: false,
        message_flag: false,
        total_words: "",
    });

    const [bookOwner, setBookOwner] = React.useState(null);
    const [bookOwnerId, setBookOwnerId] = useState(bookData?.userId || "");
    const [ownerLoading, setOwnerLoading] = React.useState(false);
    const [showOwnerEditor, setShowOwnerEditor] = useState(false);
    const [ownerTariffPlan, setOwnerTariffPlan] = useState("");
    const [ownerAmazonName, setOwnerAmazonName] = useState("");
    const [ownerAudibleName, setOwnerAudibleName] = useState("");
    const [ownerAmazonSite, setOwnerAmazonSite] = useState("");
    const [ownerAudibleSite, setOwnerAudibleSite] = useState("");
    const [ownerAmazonAttempts, setOwnerAmazonAttempts] = useState(0);
    const [ownerAudibleAttempts, setOwnerAudibleAttempts] = useState(0);
    const [ownerVirtAmount, setOwnerVirtAmount] = useState(0);
    const [ownerTrustAmount, setOwnerTrustAmount] = useState(0);
    const [ownerUsdAmount, setOwnerUsdAmount] = useState(0);
    const [ownerAffAmount, setOwnerAffAmount] = useState(0);
    const [ownerBalanceMessage, setOwnerBalanceMessage] = useState("");
    const [bookPanelMode, setBookPanelMode] = useState(null);
    const [bookPanelLoading, setBookPanelLoading] = useState(false);
    const [bookPanelError, setBookPanelError] = useState("");
    const [bookPanelLogs, setBookPanelLogs] = useState([]);
    const [bookPanelLinked, setBookPanelLinked] = useState(null);
    const [bookPanelAssignments, setBookPanelAssignments] = useState([]);
    const [bookPanelCount, setBookPanelCount] = useState(0);

    const [showMarketplaces, setShowMarketplaces] = useState(false);
    const [territoriesMode, setTerritoriesMode] = useState('WORLDWIDE'); // 'WORLDWIDE' | 'MARKETPLACES'
    const [availableMarketplaces, setAvailableMarketplaces] = useState([]); // ['com','de','co.uk',...]
    const [checkingMarketplaces, setCheckingMarketplaces] = useState(false);
    const [marketplaceCheckAttempts, setMarketplaceCheckAttempts] = useState(0);

    const MARKETPLACE_OPTIONS = [
        { code: 'com', label: 'Amazon.com (US)' },
        { code: 'co.uk', label: 'Amazon.co.uk (UK)' },
        { code: 'ca', label: 'Amazon.ca (CA)' },

        { code: 'de', label: 'Amazon.de (DE)' },
        { code: 'fr', label: 'Amazon.fr (FR)' },
        { code: 'it', label: 'Amazon.it (IT)' },
        { code: 'es', label: 'Amazon.es (ES)' },

        { code: 'co.jp', label: 'Amazon.co.jp (JP)' },
        { code: 'com.au', label: 'Amazon.com.au (AU)' },
        { code: 'in', label: 'Amazon.in (IN)' },

        { code: 'com.mx', label: 'Amazon.com.mx (MX)' },
        { code: 'com.br', label: 'Amazon.com.br (BR)' },
    ];

    const userStatusOptions = ["FREE", "ESSENTIAL", "PREMIUM", "MAXIMUM", "SUSPENDED"];
    const amazonSites = [
        { code: "US", url: "https://www.amazon.com", label: "Amazon USA" },
        { code: "UK", url: "https://www.amazon.co.uk", label: "Amazon UK" },
        { code: "CA", url: "https://www.amazon.ca", label: "Amazon Canada" },
        { code: "DE", url: "https://www.amazon.de", label: "Amazon Germany" },
        { code: "FR", url: "https://www.amazon.fr", label: "Amazon France" },
        { code: "IT", url: "https://www.amazon.it", label: "Amazon Italy" },
        { code: "ES", url: "https://www.amazon.es", label: "Amazon Spain" },
        { code: "JP", url: "https://www.amazon.co.jp", label: "Amazon Japan" },
        { code: "AU", url: "https://www.amazon.com.au", label: "Amazon Australia" },
        { code: "IN", url: "https://www.amazon.in", label: "Amazon India" },
        { code: "MX", url: "https://www.amazon.com.mx", label: "Amazon Mexico" },
        { code: "BR", url: "https://www.amazon.com.br", label: "Amazon Brazil" },
        { code: "CN", url: "https://www.amazon.cn", label: "Amazon China" },
    ];
    const audibleSites = [
        { code: "AUS", url: "https://www.audible.com", label: "Audible USA" },
        { code: "AUK", url: "https://www.audible.co.uk", label: "Audible UK" },
    ];

    const parseMarketplacesValue = (v) => {
        if (!v) return [];
        if (Array.isArray(v)) return v.filter(Boolean);

        const s = String(v).trim();
        if (!s) return [];

        if (s.startsWith("[") && s.endsWith("]")) {
            try {
                const arr = JSON.parse(s);
                return Array.isArray(arr) ? arr.filter(Boolean) : [];
            } catch {}
        }

        return s
            .split(/[,;|\n]+/g)
            .map((x) => x.trim())
            .filter(Boolean);
    };

    const getFirstAvailableAmazonAsin = () => (
        kindleAsinState ||
        paperbackAsinState ||
        hardcoverAsinState ||
        audioAsinState ||
        audibleAsinState ||
        bookData?.kindle_asin ||
        bookData?.paper_back_asin ||
        bookData?.hard_cover_asin ||
        bookData?.audio_asin ||
        bookData?.audio_audible_asin ||
        ''
    ).trim().toUpperCase();

    const openMarketplaceAmazonLink = async (marketplaceCode, event) => {
        event?.preventDefault?.();
        event?.stopPropagation?.();

        const asin = getFirstAvailableAmazonAsin();
        if (!/^[A-Z0-9]{10}$/.test(asin)) {
            toast.info("Add at least one ASIN before opening Amazon.", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
            });
            return;
        }

        try {
            const targetUrl = `https://www.amazon.${marketplaceCode}/dp/${asin}`;
            const response = await getRedirectUrlApi(targetUrl);
            if (response?.redirectUrl) {
                window.open(response.redirectUrl, "_blank", "noopener noreferrer");
            }
        } catch (error) {
            toast.error("Failed to open Amazon marketplace.", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
            });
        }
    };

    const renderMarketplaceLink = (m, text = m.label) => (
        <button
            type="button"
            className="btn btn-link btn-sm p-0 align-baseline text-decoration-none"
            onClick={(event) => openMarketplaceAmazonLink(m.code, event)}
        >
            {text}
        </button>
    );



    const bookSizes = {
        "6x9": { aspectRatio: 6 / 9 },
        "8x10": { aspectRatio: 8 / 10 },
        "8.5x11": { aspectRatio: 8.5 / 11 },
        "5x8": { aspectRatio: 5 / 8 },
        "7x10": { aspectRatio: 7 / 10 },
    };
    const statusOptions = ["LIVE", "NEW", "PAY_DEL", "DELETED", "NEEDFIX"];

    const setStatusSafe = (v) => {
        const s = typeof v === 'string'
            ? v
            : (v?.target?.value ?? v?.value ?? v?.status ?? String(v ?? ''));
        setStatus(String(s));
    };

    React.useEffect(() => {
        let alive = true;
        const uid = bookData?.userId; // берём как ты сказал — iserId

        const load = async () => {
            if (!uid) return;
            try {
                setOwnerLoading(true);
                const data = await fetchUserDataById(uid);
                if (alive) setBookOwner(data || null);
            } catch (e) {
                if (alive) setBookOwner(null);
                // необязательно: toast.warn("Cannot load book owner data");
            } finally {
                if (alive) setOwnerLoading(false);
            }
        };

        load();
        return () => {
            alive = false;
            // оффим/очищаем при выходе
            setBookOwner(null);
        };
    }, [bookData?.userId]);

    useEffect(() => {
        if (!show || !bookOwner) return;
        setOwnerTariffPlan(bookOwner.tariff_plan || "");
        setOwnerAmazonName(bookOwner.amz_name || "");
        setOwnerAudibleName(bookOwner.audible_name || "");
        setOwnerAmazonSite(bookOwner.amz_country || "");
        setOwnerAudibleSite(bookOwner.audible_country || "");
        setOwnerAmazonAttempts(bookOwner.amazon_rn_changes || 0);
        setOwnerAudibleAttempts(bookOwner.audible_rn_changes || 0);
        setOwnerVirtAmount(0);
        setOwnerTrustAmount(0);
        setOwnerUsdAmount(0);
        setOwnerAffAmount(0);
        setOwnerBalanceMessage("");
    }, [show, bookOwner?.userId]);

    const refreshBookOwner = async () => {
        const uid = bookData?.userId;
        if (!uid) return;
        try {
            const data = await fetchUserDataById(uid);
            setBookOwner(data || null);
        } catch (error) {
            console.error("Owner refresh failed:", error);
        }
    };

    const saveOwnerProfileChanges = async () => {
        if (!bookOwner?.userId) return;
        try {
            const updatedData = {
                id: bookOwner.userId,
                tariff_plan: ownerTariffPlan,
                amz_name: ownerAmazonName,
                amz_country: ownerAmazonSite,
                audible_name: ownerAudibleName,
                audible_country: ownerAudibleSite,
                amazon_rn_changes: ownerAmazonAttempts,
                audible_rn_changes: ownerAudibleAttempts,
            };
            await updateUserDataAdminFront(updatedData);
            setBookOwner((prev) => prev ? { ...prev, ...updatedData } : prev);
            toast.success("User updated!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            await refreshBookOwner();
        } catch (error) {
            toast.error("Failed to update user", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            console.error("Owner update failed:", error);
        }
    };

    const saveOwnerBalanceChanges = async () => {
        if (!bookOwner?.userId) return;
        const virtAmount = Number(ownerVirtAmount) || 0;
        const usdAmount = Number(ownerUsdAmount) || 0;
        const trustAmount = Number(ownerTrustAmount) || 0;
        const affAmount = Number(ownerAffAmount) || 0;
        const hasAnyValue = [virtAmount, usdAmount, trustAmount, affAmount].some((v) => !Number.isNaN(v) && v !== 0);

        if (!hasAnyValue) {
            toast.info("Please enter at least one non-zero value", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        try {
            const response = await userBalanceChangeApi(
                bookOwner.userId,
                virtAmount,
                usdAmount,
                trustAmount,
                affAmount,
                ownerBalanceMessage
            );
            toast.info(response?.message || "Data Updated Successfully", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            setOwnerVirtAmount(0);
            setOwnerUsdAmount(0);
            setOwnerTrustAmount(0);
            setOwnerAffAmount(0);
            setOwnerBalanceMessage("");
            await refreshBookOwner();
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to change user balance", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
            });
        }
    };

    const clearBookPanel = () => {
        setBookPanelMode(null);
        setBookPanelLoading(false);
        setBookPanelError("");
        setBookPanelLogs([]);
        setBookPanelLinked(null);
        setBookPanelAssignments([]);
        setBookPanelCount(0);
    };

    const getAssignmentRows = (response) => {
        if (Array.isArray(response?.items)) return response.items;
        if (Array.isArray(response?.assignments)) return response.assignments;
        return [];
    };

    const loadBookPanel = async (mode) => {
        const ownerId = bookOwner?.userId || bookData?.userId;
        const targetBookId = bookData?.id;
        if (!ownerId || !targetBookId) return;

        setBookPanelMode(mode);
        setBookPanelLoading(true);
        setBookPanelError("");
        setBookPanelLogs([]);
        setBookPanelLinked(null);
        setBookPanelAssignments([]);
        setBookPanelCount(0);

        try {
            if (mode === "bookLogs") {
                const logs = await fetchUserLogsBA(ownerId, "book", targetBookId, 500);
                const rows = Array.isArray(logs) ? logs : [];
                setBookPanelLogs(rows);
                if (!rows.length) setBookPanelError("No logs found for this book.");
                return;
            }

            if (mode === "userLogs") {
                const logs = await fetchUserLogs(ownerId, 500);
                const rows = Array.isArray(logs) ? logs : [];
                setBookPanelLogs(rows);
                if (!rows.length) setBookPanelError("No logs found for this user.");
                return;
            }

            if (mode === "linked") {
                const resp = await getLinkedByUserApi(ownerId, {
                    lookbackDays: 90,
                    minSignals: 2,
                    includeGuests: false,
                    excludeNulls: true,
                    page: 1,
                    limit: 50,
                });
                setBookPanelLinked(resp);
                if ((resp?.total_matches ?? 0) === 0) {
                    setBookPanelError("No linked accounts found in the selected window.");
                }
                return;
            }

            if (mode === "assignments") {
                const response = await fetchAssignmentsAdmin({
                    bookId: targetBookId,
                    page: 1,
                    limit: 100,
                });
                const rows = getAssignmentRows(response);
                setBookPanelAssignments(rows);
                setBookPanelCount(Number(response?.count || rows.length || 0));
                if (!rows.length) setBookPanelError("No assignments found for this book.");
            }
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Failed to load data.";
            setBookPanelError(message);
            toast.error(message, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } finally {
            setBookPanelLoading(false);
        }
    };

    const shortText = (value, max = 48) => {
        const text = String(value || "");
        return text.length > max ? `${text.slice(0, max)}...` : text || "N/A";
    };

    const formatDateCell = (value) => {
        if (!value) return "N/A";
        const date = typeof value === "number" ? new Date(value * 1000) : new Date(value);
        if (Number.isNaN(date.getTime())) return "N/A";
        return date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    const formatMinutesCell = (minutes) => {
        if (!minutes && minutes !== 0) return "N/A";
        return formatDateCell(Number(minutes) * 60);
    };

    const hostFromUrl = (u) => {
        try { return new URL(u).hostname; } catch { return u || ""; }
    };


    // normalize: убираем диакритику/лишнее, к нижнему регистру
    const norm = (s) =>
        (s || "")
            .normalize("NFD").replace(/\p{Diacritic}/gu, "")
            .replace(/[^a-z0-9&+ ]/gi, " ")
            .replace(/\s+/g, " ")
            .trim()
            .toLowerCase();

// Подбор языка по строке из Amazon: data.language
    const resolveLanguage = (amzLanguage, languages) => {
        const n = norm(amzLanguage);
        if (!n) return null;

        // быстрые синонимы (дополняй при желании)
        const ALIAS = {
            english: "english",
            en: "english",
            espanol: "spanish",
            spanish: "spanish",
            deutsch: "german",
            german: "german",
            francais: "french",
            french: "french",
            italiano: "italian",
            italian: "italian",
        };
        const target = ALIAS[n] || n;

        // 1) точное совпадение по нормализованному названию
        let found = languages?.find((l) => norm(l.language) === target);
        if (found) return found;

        // 2) "включения" (English (US), English Language и т.п.)
        found = languages?.find(
            (l) => norm(l.language).includes(target) || target.includes(norm(l.language))
        );
        return found || null;
    };

// Подбор жанра по categories_path / categories
    const splitCats = (categories_path, categories) => {
        const fromPath = (categories_path || "")
            .split("›")
            .map((s) => s.trim())
            .filter(Boolean);
        const fromArr = Array.isArray(categories) ? categories : [];
        // Склеим и уберём дубли
        const merged = [...fromPath, ...fromArr];
        const seen = new Set();
        return merged.filter((x) => {
            const k = norm(x);
            if (!k || seen.has(k)) return false;
            seen.add(k);
            return true;
        });
    };

// Набросок синонимов по “пазлам” и пр. — расширяй под свою матрицу жанров
    const GENRE_SYNONYMS = {
        "puzzles & games": ["puzzles", "word search", "crosswords", "sudoku", "logic puzzles", "activity books"],
        "humor & entertainment": ["humor", "entertainment"],
        "business & money": ["business", "money", "finance"],
    };

// Возвращает ЛУЧШИЙ матч жанра из store.book.genres
    const resolveGenre = (categories_path, categories, genres) => {
        const cats = splitCats(categories_path, categories); // слева->справа
        if (!cats.length) return null;

        const catsN = cats.map(norm);

        // 1) прямое совпадение/подстрока: справа-налево (самая узкая ветка в конце)
        for (let i = catsN.length - 1; i >= 0; i--) {
            const c = catsN[i];
            const direct = genres?.find((g) => {
                const gName = norm(g.genre);
                return gName === c || gName.includes(c) || c.includes(gName);
            });
            if (direct) return direct;
        }

        // 2) через синонимы: если категория попала в известную группу, ищем жанр, содержащий ключ этой группы
        for (let i = catsN.length - 1; i >= 0; i--) {
            const c = catsN[i];
            for (const [group, keys] of Object.entries(GENRE_SYNONYMS)) {
                if (keys.some((k) => c.includes(k))) {
                    const byGroup = genres?.find(
                        (g) => norm(g.genre).includes(group) || group.includes(norm(g.genre))
                    );
                    if (byGroup) return byGroup;
                }
            }
        }

        // 3) fallback: берём последний сегмент как самый специфичный и ищем ближайшее “включение”
        const last = catsN[catsN.length - 1];
        return (
            genres?.find(
                (g) => norm(g.genre).includes(last) || last.includes(norm(g.genre))
            ) || null
        );
    };


    useEffect(() => {
        const updateSize = () => {
            if (parentRef.current) {
                const parentWidth = parentRef.current.clientWidth;
                const selectedSize = bookSizes[bookFormat] || bookSizes["6x9"];
                const newHeight = parentWidth / selectedSize.aspectRatio;
                setEditorSize({ width: parentWidth, height: newHeight });
            }
        };

        updateSize();
        window.addEventListener("resize", updateSize);
        return () => window.removeEventListener("resize", updateSize);
    }, [bookFormat]); // Обновление при изменении формата книги

    const triggerFileInput = () => {
        document.getElementById("fileInput").click();
    };

    const triggerFileInputBook = () => {
        document.getElementById("fileInputBook").click();
    };

    useEffect(() => {
        if (show && bookData) {
            setTitleState(bookData?.title || '');
            setSubTitleState(bookData?.subtitle || '');
            setAuthorState(bookData?.author || '');
            setSummaryState(bookData?.summary || '');
            setPaperBackAsinState(bookData?.paper_back_asin || '');
            setKindleAsinState(bookData?.kindle_asin || '');
            setHardCoverAsinState(bookData?.hard_cover_asin || '');
            setAudioAsinState(bookData?.audio_asin || '');
            setAudibleAsinState(bookData.audio_audible_asin || '');
            setAudioBookLinkState(bookData.audio_download_link_ned || '');
            setTempPDFFile(bookData?.book_temp_file || '');
            setPdfFileTitle(bookData.book_download || '');
            setCoverPreview(`${process.env.REACT_APP_API_URL}covers/${bookData?.cover_file}`);
            setStatus(bookData?.status || '');
            setBookOwnerId(bookData?.userId || '');
            setKindlePriceState(bookData?.kindle_list_price_on_amazon_decimal);
            setPaperbackPriceState(bookData?.paper_back_list_price_on_amazon_decimal);
            setHardcoverPriceState(bookData?.hard_cover_list_price_on_amazon_decimal);
            setEditAdminBook(bookData);
            setNoManuscript((bookData?.book_download || '').toUpperCase() === 'NO_MANUSCRIPT');
            setGrabAttempts(0);
            setCheckingMarketplaces(false);
            setMarketplaceCheckAttempts(0);

            if (bookData?.booksLanguageId) {
                const selectedLang = book.languages.find(lang => lang.id === bookData.booksLanguageId);
                if (selectedLang) {
                    book.setSelectedLanguage(selectedLang);
                }
            }

            if (bookData?.booksGenreId) {
                const selectedGenre = book.genres.find(gen => gen.id === bookData.booksGenreId);
                if (selectedGenre) {
                    book.setSelectedGenre(selectedGenre);
                }
            }
            const totalWords = Number(bookData?.total_words);
            let matchedWordCountOption = null;

            if (totalWords) {
                const matchedOption = wordCountOptions.find(opt => opt.count === totalWords);
                if (matchedOption) {
                    matchedWordCountOption = matchedOption;
                    setSelectedWordCount(matchedOption);
                } else {
                    setSelectedWordCount(null);
                }
            } else {
                setSelectedWordCount(null);
            }
            setEditAdminBook({
                paper_back_flag: bookData?.paper_back_flag || false,
                kindle_flag: bookData?.kindle_flag || false,
                kindle_unlimited_flag: bookData?.kindle_unlimited_flag || false,
                hard_cover_flag: bookData?.hard_cover_flag || false,
                audio_flag: bookData?.audio_flag || false,
                audio_exclusive_flag: bookData?.audio_exclusive_flag || false,
                audio_non_exclusive_flag: bookData?.audio_non_exclusive_flag || false,
                message_flag: bookData?.message_flag || false,
                total_words: bookData?.total_words || "",
                amz_price: bookData?.amz_price || "",
                default_price: matchedWordCountOption?.price ?? bookData?.default_price ?? "",
                default_decrement: bookData?.default_decrement || "",
                book_type: bookData?.book_type || "",
                language: bookData?.language || "",
                message: bookData?.message || "",
                book_download: bookData?.book_download || "",
                cover_file: bookData?.cover_file || "",
                audio_download_link_ned: bookData?.audio_download_link_ned || "",

            });
            setTerritoriesMode(bookData?.territories_mode || 'WORLDWIDE');
           // setShowMarketplaces((bookData?.territories_mode || 'WORLDWIDE') === 'MARKETPLACES');
            setAvailableMarketplaces(parseMarketplacesValue(bookData?.available_marketplaces));

        }
    }, [show, bookData, book.languages, book.genres]);

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setEditAdminBook(prev => {
            const next = { ...prev, [name]: checked };
            if (name === 'audio_exclusive_flag' && checked) next.audio_non_exclusive_flag = false;
            if (name === 'audio_non_exclusive_flag' && checked) next.audio_exclusive_flag = false;
            // NEW: если снимаем audio_flag — снимаем оба саб-флага
            if (name === 'audio_flag' && !checked) {
                next.audio_exclusive_flag = false;
                next.audio_non_exclusive_flag = false;
            }
            // NEW: если снимаем kindle_flag — снимаем KU
            if (name === 'kindle_flag' && !checked) {
                next.kindle_unlimited_flag = false;
            }
            return next;
        });
    };

    const internalHandleClose = () => {
        setTitleState('');
        setSubTitleState('');
        setAuthorState('');
        setSummaryState('');
        setPaperBackAsinState('');
        setKindleAsinState('');
        setHardCoverAsinState('');
        setAudioAsinState('');
        setTempPDFFile('');
        setPdfFileTitle('');
        setCoverPreview(null);
        setCoverFileState(null);
        setBookOwnerId('');
        book.setSelectedLanguage({});
        book.setSelectedGenre({});
        setStatus('');
        setHardcoverPriceState('');
        setPaperbackPriceState('');
        setKindlePriceState('');
            setFullGrabbedData({});
            setTerritoriesMode('WORLDWIDE');
            setAvailableMarketplaces([]);
            setCheckingMarketplaces(false);
            setMarketplaceCheckAttempts(0);
            setShowOwnerEditor(false);
            setOwnerTariffPlan("");
            setOwnerAmazonName("");
            setOwnerAudibleName("");
            setOwnerAmazonSite("");
            setOwnerAudibleSite("");
            setOwnerAmazonAttempts(0);
            setOwnerAudibleAttempts(0);
            setOwnerVirtAmount(0);
            setOwnerTrustAmount(0);
            setOwnerUsdAmount(0);
            setOwnerAffAmount(0);
            setOwnerBalanceMessage("");
            clearBookPanel();

        handleClose();
    };

    const closeAndOpenSearch = (handler, value) => {
        const targetValue = value ? String(value) : "";
        internalHandleClose();
        if (targetValue && typeof handler === "function") {
            handler(targetValue);
        }
    };

    const handleManuscriptDownload = async () => {
        if (!bookData?.id) return;
        setDownloadModal({
            show: true,
            progress: 0,
            status: "Preparing secure manuscript download...",
        });
        try {
            await downloadWithProgress({
                path: `api/book/${bookData.id}/manuscript-download`,
                filename: `${bookData?.title || "virtalibry-manuscript"}.pdf`,
                onProgress: (progress) => setDownloadModal((prev) => ({ ...prev, progress })),
                onStatus: (status) => setDownloadModal((prev) => ({ ...prev, status })),
            });
            setTimeout(() => {
                setDownloadModal((prev) => ({ ...prev, show: false }));
            }, 700);
        } catch (error) {
            console.error("Manuscript download failed:", error);
            setDownloadModal((prev) => ({ ...prev, status: "Download failed. Please try again." }));
            toast.error("Failed to download manuscript. Please try again.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            setTimeout(() => setDownloadModal((prev) => ({ ...prev, show: false })), 1400);
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith("image/")) {
            setOriginalCover(file);
            const reader = new FileReader();
            reader.onload = (event) => {
                const imageBase64 = event.target.result;

                setCoverPreview(imageBase64);
                setShowEditor(true);


            };
            reader.readAsDataURL(file);
        }
    };
    const handleSave = () => {
        if (editorRef) {
            try {
                const canvas = editorRef.getImageScaledToCanvas();
                canvas.toBlob(
                    (blob) => {
                        if (blob) {
                            const reader = new FileReader();
                            reader.onload = (event) => {
                                const editedImageBase64 = event.target.result;
                                setCoverPreview(editedImageBase64);
                                setCoverFileState(blob);
                                setShowEditor(false);
                            };
                            reader.readAsDataURL(blob);
                        } else {

                        }
                    },
                    'image/jpeg',
                    0.9
                );
            } catch (error) {

            }
        } else {

        }
    };
    const handleEditOriginal = () => {
        let coverToEdit = originalCover;


        // ✅ Загружаем обложку в редактор
        setCoverPreview(coverToEdit);
        setShowEditor(true);
    };
    const selectBookFile = (e) => {
        const file = e.target.files[0];
        if (!file) {
            toast.error("❌ Error: No file selected.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        // 🔹 Проверка формата и размера файла
        if (file.type !== "application/pdf") {
            toast.error(`❌ Error: File "${file.name}" is not a PDF.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        const maxFileSize = 500 * 1024 * 1024; // 500MB in bytes
        if (file.size > maxFileSize) {
            toast.error(`❌ Error: File "${file.name}" exceeds 500MB limit.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        // 🔹 Обновляем состояние файла
        setPdfFile(file);
        setPdfFileTitle(file.name); // Save the original file name


        // 🔹 Создаем `FormData` и загружаем файл
        const formData = new FormData();
        formData.append("book_download_temp", file);

        try {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", process.env.REACT_APP_API_URL + "api/book/temp", true);

            // 🔹 Обработчик прогресса
            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    const percentComplete = Math.round((event.loaded / event.total) * 100);
                    setUploadProgress(percentComplete >= 100 ? 99 : percentComplete);
                }
            };

            // 🔹 Обработчик завершения загрузки
            xhr.onload = () => {
                if (xhr.status === 200) {
                    toast.success("✅ File uploaded successfully!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

                    const response = JSON.parse(xhr.responseText);
                    const tempFileName = response.tempPDFFile;

                    // 🔹 Save temporary file name
                    setTempPDFFile(tempFileName);


                    setUploadProgress(100);
                } else {
                    let errorMessage = `Upload failed: ${xhr.status}`;
                    try {
                        errorMessage = JSON.parse(xhr.responseText)?.message || errorMessage;
                    } catch (_) {}
                    toast.error(errorMessage, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                    setUploadProgress(-1);
                }
            };

            // 🔹 Обработчик ошибок
            xhr.onerror = () => {
                toast.error("Error uploading file.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                setUploadProgress(-1);
            };

            // 🔹 Отправляем файл на сервер
            xhr.send(formData);
        } catch (error) {
            toast.error(`Error sending file: ${error.message}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        }
    };

    const handleSetLive = async () => {
        flushSync(() => setStatusSafe('LIVE'));
    };
    useEffect(() => { console.log('status state ->', status); }, [status]);

    const checkAmazonMarketplaces = async () => {
        if (marketplaceCheckAttempts >= 3) return;

        const payload = {
            marketplaces: MARKETPLACE_OPTIONS.map((m) => m.code),
            kindle_asin: kindleAsinState || bookData?.kindle_asin || '',
            paper_back_asin: paperbackAsinState || bookData?.paper_back_asin || '',
            hard_cover_asin: hardcoverAsinState || bookData?.hard_cover_asin || '',
            audio_asin: audioAsinState || bookData?.audio_asin || '',
            audio_audible_asin: audibleAsinState || bookData?.audio_audible_asin || '',
        };

        const hasAnyAsin = [
            payload.kindle_asin,
            payload.paper_back_asin,
            payload.hard_cover_asin,
            payload.audio_asin,
            payload.audio_audible_asin,
        ].some((asin) => /^[A-Z0-9]{10}$/i.test(String(asin || '').trim()));

        if (!hasAnyAsin) {
            toast.info("Add at least one ASIN before checking marketplaces.", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
            });
            return;
        }

        try {
            setMarketplaceCheckAttempts((prev) => prev + 1);
            setCheckingMarketplaces(true);
            const data = await checkMarketplaceAvailabilityApi(payload);
            const found = Array.isArray(data?.availableMarketplaces) ? data.availableMarketplaces : [];

            setTerritoriesMode("MARKETPLACES");
            setAvailableMarketplaces(found);
            setShowMarketplaces(true);

            if (found.length > 0) {
                toast.success(`Found availability on ${found.length} Amazon marketplace${found.length === 1 ? '' : 's'}.`, {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                });
            } else {
                toast.warn("No available Amazon marketplaces were detected for the current ASINs.", {
                    position: "bottom-center",
                    autoClose: 4000,
                    hideProgressBar: false,
                });
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || "Failed to check Amazon marketplaces.";
            toast.error(errorMessage, { position: "bottom-center", autoClose: 4000, hideProgressBar: false });
        } finally {
            setCheckingMarketplaces(false);
        }
    };

    const duplicateBookIds = Array.isArray(duplicateInfo?.bookIds)
        ? duplicateInfo.bookIds.map(Number).filter((id) => Number.isInteger(id) && id > 0)
        : [];
    const canResolveDuplicate = duplicateBookIds.length >= 2;

    const handleResolveDuplicate = async () => {
        if (!canResolveDuplicate) {
            toast.info("Open this book from a duplicate group first.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        const sortedIds = [...new Set(duplicateBookIds)].sort((a, b) => a - b);
        const keepId = sortedIds[0];
        const deleteId = sortedIds[sortedIds.length - 1];
        const ok = window.confirm(
            `Remove duplicate?\n\nBook #${deleteId} will be marked DELETED. Book #${keepId} will be assigned to the owner of book #${deleteId}.`
        );
        if (!ok) return;

        setLoading(true);
        try {
            const data = await adminResolveBookDuplicate({ bookIds: sortedIds });
            toast.success(data?.message || "Duplicate resolved.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            if (onUpdate) onUpdate();
            internalHandleClose();
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Failed to resolve duplicate.";
            toast.error(message, { position: "bottom-center", autoClose: 4000, hideProgressBar: false });
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateBook = async () => {
        if (territoriesMode === 'MARKETPLACES' && availableMarketplaces.length === 0) {
            toast.info('Select at least one marketplace!', { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        if (!titleState || !subtitleState || !authorState) {
            toast.info('Enter Title, Subtitle and Author!', { position: "bottom-center", autoClose: 3000, hideProgressBar: false }); return;
        }
        if (!book.selectedLanguage?.id || !book.selectedGenre?.id ||
            !(editAdminBook.paper_back_flag || editAdminBook.kindle_flag || editAdminBook.hard_cover_flag || editAdminBook.audio_flag)) {
            toast.info('Set Language, Genre and Type!', { position: "bottom-center", autoClose: 3000, hideProgressBar: false }); return;
        }
        if (editAdminBook.audio_flag && !(editAdminBook.audio_exclusive_flag || editAdminBook.audio_non_exclusive_flag)) {
            toast.info('Set Contract Type for Audio Book!', { position: "bottom-center", autoClose: 3000, hideProgressBar: false }); return;
        }
        if (!summaryState) {
            toast.info('Enter the Summary of Book!', { position: "bottom-center", autoClose: 3000, hideProgressBar: false }); return;
        }
        if (editAdminBook.kindle_flag && !kindleAsinState) { toast.info('Please enter a Kindle ASIN!', { position: "bottom-center", autoClose: 3000, hideProgressBar: false }); return; }
        if (editAdminBook.paper_back_flag && !paperbackAsinState) { toast.info('Please enter a Paperback ASIN!', { position: "bottom-center", autoClose: 3000, hideProgressBar: false }); return; }
        if (editAdminBook.hard_cover_flag && !hardcoverAsinState) { toast.info('Please enter a Hard Cover ASIN!', { position: "bottom-center", autoClose: 3000, hideProgressBar: false }); return; }
        if (editAdminBook.audio_flag && !audioAsinState) { toast.info('Please enter an Amazon Audio ASIN!', { position: "bottom-center", autoClose: 3000, hideProgressBar: false }); return; }
        if ((editAdminBook.audio_exclusive_flag || editAdminBook.audio_non_exclusive_flag) && !audibleAsinState) {
            toast.info('Please enter an Audible ASIN!', { position: "bottom-center", autoClose: 3000, hideProgressBar: false }); return;
        }
        if (editAdminBook.audio_non_exclusive_flag && !audioBookLinkState) {
            toast.info('Please, enter a link to download!', { position: "bottom-center", autoClose: 3000, hideProgressBar: false }); return;
        }
        setLoading(true);
        try {
            const formData = new FormData();

            const appendIfString = (k, v) => { if (v !== undefined && v !== null && `${v}`.trim() !== "") formData.append(k, v); };
            const appendNumber = (k, v) => {
                if (v === undefined || v === null || `${v}`.trim?.() === "") return;
                const n = Number(String(v).replace(",", "."));
                if (Number.isFinite(n)) formData.append(k, n);
            };

            // Строковые цены:
            appendIfString("kindle_price_on_amazon", kindlePriceState);
            appendIfString("paper_back_price_on_amazon", paperbackPriceState);
            appendIfString("hard_cover_price_on_amazon", hardcoverPriceState);

            // Числовые дубли:
            appendNumber("kindle_list_price_on_amazon_decimal", kindlePriceState);
            appendNumber("paper_back_list_price_on_amazon_decimal", paperbackPriceState);
            appendNumber("hard_cover_list_price_on_amazon_decimal", hardcoverPriceState);

            // Базовые поля:
            formData.append('booksGenreId', book.selectedGenre.id || bookData.booksGenreId);
            formData.append('booksLanguageId', book.selectedLanguage.id || bookData.booksLanguageId);

            formData.append('title', titleState || '');
            formData.append('subtitle', subtitleState || '');
            formData.append('author', authorState || '');
            formData.append('summary', summaryState || '');
            if (editAdminBook.description_full != null) {
                appendIfString('description_full', editAdminBook.description_full || summaryState || '');
            }

            // Флаги и идентификаторы:
            formData.append('kindle_flag', !!editAdminBook.kindle_flag);
            formData.append('kindle_unlimited_flag', !!editAdminBook.kindle_unlimited_flag);
            formData.append('paper_back_flag', !!editAdminBook.paper_back_flag);
            formData.append('hard_cover_flag', !!editAdminBook.hard_cover_flag);
            formData.append('audio_flag', !!editAdminBook.audio_flag);
            formData.append('audio_exclusive_flag', !!editAdminBook.audio_exclusive_flag);
            formData.append('audio_non_exclusive_flag', !!editAdminBook.audio_non_exclusive_flag);
            formData.append('message_flag', true);
            formData.append('message', editAdminBook.message);


            formData.append('paper_back_asin', paperbackAsinState || '');
            formData.append('kindle_asin', kindleAsinState || '');
            formData.append('hard_cover_asin', hardcoverAsinState || '');
            formData.append('audio_asin', audioAsinState || '');
            formData.append('audio_audible_asin', audibleAsinState || '');
            formData.append('audio_download_link_ned', audioBookLinkState || '');
            formData.append('userId', bookOwnerId || bookData?.userId || '');

            if (selectedWordCount?.count) formData.append('total_words', selectedWordCount.count);
            if (editAdminBook.default_price != null) formData.append('default_price', editAdminBook.default_price);
            appendNumber('default_decrement', editAdminBook.default_decrement);

            formData.append('no_manuscript', noManuscript ? '1' : '0');

            formData.append('last_update_book_data_from_amazon_date', Math.floor(Date.now()/1000));

            if (coverFileState) formData.append('cover_file', coverFileState);
            if (!noManuscript && tempPDFFile) formData.append('book_download', tempPDFFile);

            const statusToSend = String(status ?? bookData?.status ?? '').trim();
            if (statusToSend) formData.append('status', statusToSend);

            formData.append('territories_mode', territoriesMode);
            formData.append(
                'available_marketplaces',
                JSON.stringify(territoriesMode === 'WORLDWIDE' ? [] : availableMarketplaces)
            );

            const data = await updateBook(bookData.id, formData); // data уже готов

            toast.success(data.message, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

            if (onUpdate) {
                onUpdate(); // Вызов обновления в родительском компоненте
            }

            internalHandleClose();
        } catch (error) {
            console.error("Error updating book:", error);
            toast.error("Error updating book!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } finally {
            setLoading(false);
        }
    };
    const handleWordCountSelect = (option) => {
        setSelectedWordCount(option);
        setEditAdminBook(prev => ({
            ...prev,
            total_words: option.count,
            default_price: option.price,
        }));
    };

    const fmtUSD = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n);
    const priceSuffix = (v) => {
        const n = Number(v);
        return Number.isFinite(n) && n > 0 ? ` (${fmtUSD(n)})` : '';
    };
    const fetchCoverDirect = async (url) => {
        const resp = await fetch(url, { credentials: 'omit', mode: 'cors' });
        if (!resp.ok) throw new Error(`direct fetch failed: ${resp.status}`);
        const blob = await resp.blob();
        return { blob, contentType: blob.type || 'image/jpeg' };
    };
    const blobToFile = (blob, contentType, filenameHint='cover') => {
        const ext = (contentType.split('/')[1] || 'jpg').split(';')[0];
        return new File([blob], `${filenameHint}.${ext}`, { type: contentType });
    };
    const blobToBase64 = (blob) => new Promise((res, rej) => {
        const r = new FileReader(); r.onloadend = () => res(r.result); r.onerror = rej; r.readAsDataURL(blob);
    });
    const downloadAndSetCover = async (imageUrl, filenameHint='cover') => {
        if (!imageUrl) return;
        try {
            const got = await fetchCoverDirect(imageUrl);
            const file = blobToFile(got.blob, got.contentType, filenameHint);
            setCoverFileState(file);
            const base64 = await blobToBase64(file);
            setCoverPreview(base64);
        } catch (e) {
            toast.warn('Could not download cover automatically. You can upload it manually.', { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        }
    };
    const humanizeRelative = (inp) => {
        const d = inp instanceof Date ? inp : toDate(inp);
        if (!d) return '';
        const now = new Date();
        let diff = now.getTime() - d.getTime(); // >0 => ago
        const tense = diff >= 0 ? 'Ago' : 'From Now';
        diff = Math.abs(diff);

        const sec = Math.floor(diff / 1000);
        let n, unit;
        if (sec < 60) { n = sec; unit = 'S'; }
        else if (sec < 3600) { n = Math.floor(sec / 60); unit = 'M'; }
        else if (sec < 86400) { n = Math.floor(sec / 3600); unit = 'H'; }
        else { n = Math.floor(sec / 86400); unit = 'D'; }

        if (n === 0) return 'Just Now';
        return `${n} ${unit}${n !== 1 ? '-s' : ''} ${tense}`;
    };
    const formatTime = (v) => {
        const d = toDate(v*1000);
        if (!d) return '—';
        const dateStr = d.toLocaleDateString('en-GB', {
            day: '2-digit', month: 'short', year: 'numeric', timeZone: 'Europe/Kyiv'
        });
        const timeStr = d.toLocaleTimeString('en-GB', {
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false, timeZone: 'Europe/Kyiv'
        });
        const rel = humanizeRelative(d);
        return `${dateStr} ${timeStr}${rel ? ` (${rel})` : ''}`;
    };
    const estimateWordsByPages = (pages) => {
        const n = Number(pages);
        if (!Number.isFinite(n) || n <= 0) return null;
        return Math.round(n * 275);
    };
    const pickWordCountOptionByWords = (words, options) => {
        if (!Number.isFinite(words) || words <= 0 || !Array.isArray(options)) return null;
        const sorted = [...options].sort((a,b) => a.count - b.count);
        return sorted.find(o => words <= o.count) || sorted[sorted.length - 1];
    };

    const fetchAndFillPrices = async () => {
        if (grabAttempts >= 5) return;
        setGrabAttempts(x => x + 1);

        const asin = (kindleAsinState || paperbackAsinState || hardcoverAsinState || '').trim().toUpperCase();
        if (!/^[A-Z0-9]{10}$/.test(asin)) {
            setKindlePriceState('');
            setPaperbackPriceState('');
            setHardcoverPriceState('');
            return;
        }

        const url = `https://${hostFromUrl(bookOwner.amz_country) || 'www.amazon.com'}/dp/${asin}`;

        try {
            setIsLoading(true);

            let data = await getFullBookDataUrlApi(url);
            const hasAudioFromPrimary =
                !!data?.audio ||
                !!data?.audio_asin ||
                !!data?.audio_audible_asin ||
                !!data?.audible_asin;
            const primaryHost = hostFromUrl(bookOwner.amz_country) || 'www.amazon.com';

            if (!hasAudioFromPrimary && primaryHost !== 'www.amazon.com') {
                try {
                    const comData = await getFullBookDataUrlApi(`https://www.amazon.com/dp/${asin}`);
                    if (comData?.audio || comData?.audio_asin || comData?.audio_audible_asin || comData?.audible_asin) {
                        data = {
                            ...data,
                            audio: true,
                            audio_asin: comData.audio_asin || data?.audio_asin || '',
                            audio_audible_asin: comData.audio_audible_asin || comData.audible_asin || data?.audio_audible_asin || '',
                            audible_asin: comData.audible_asin || comData.audio_audible_asin || data?.audible_asin || '',
                            prices: {
                                ...(data?.prices || {}),
                                audio: comData?.prices?.audio || data?.prices?.audio,
                            },
                        };
                    }
                } catch (fallbackErr) {
                    console.warn('Amazon.com audio fallback failed:', fallbackErr);
                }
            }
            setFullGrabbedData(data || {});

            const lang = resolveLanguage(data?.language, book.languages);
            if (lang) {
                book.setSelectedLanguage(lang);
                setEditAdminBook(prev => ({ ...prev, language: lang.language }));
            }

            const genre = resolveGenre(data?.categories_path, data?.categories, book.genres);
            if (genre) {
                book.setSelectedGenre(genre);
            }

            // titles / authors
            setTitleState(data?.title || '');
            setSubTitleState(data?.subtitle || '');
            setAuthorState(
                (data?.authors_str && data.authors_str.trim?.()) ||
                (Array.isArray(data?.authors) ? data.authors.join(', ') : '') ||
                ''
            );

            // descriptions
            setSummaryState(data?.description_first10 || '');
            setEditAdminBook(prev => ({ ...prev, description_full: data?.description_full || '' }));

            // flags
            setEditAdminBook(prev => ({
                ...prev,
                kindle_flag: !!data?.kindle,
                kindle_unlimited_flag: !!data?.kindle_unlimited,
                paper_back_flag: !!data?.pb,
                hard_cover_flag: !!data?.hc,
                audio_flag: !!data?.audio,
                audio_exclusive_flag: !!data?.audio,   // default: exclusive=true
                audio_non_exclusive_flag: false,
            }));

            // ASINs
            setKindleAsinState(data?.kindle_asin || '');
            setPaperBackAsinState(data?.pb_asin || '');
            setHardCoverAsinState(data?.hc_asin || '');
            setAudioAsinState(data?.audio_asin || '');
            setAudibleAsinState(data?.audio_audible_asin || data?.audible_asin || '');

            // prices
            setKindlePriceState(
                Number.isFinite(data?.prices?.kindle?.value) ? String(data.prices.kindle.value) : ''
            );
            setPaperbackPriceState(
                Number.isFinite(data?.prices?.paperback?.value) ? String(data.prices.paperback.value) : ''
            );
            setHardcoverPriceState(
                Number.isFinite(data?.prices?.hardcover?.value) ? String(data.prices.hardcover.value) : ''
            );

            // cover (prefer large → medium → HowItWorks → images[0])
            await downloadAndSetCover(
                data?.image_large ||
                data?.image_medium ||
                data?.main_image ||
                (Array.isArray(data?.images) ? data.images[0] : '')
            );

            // word count & price from print_length
            const pages = Number(data?.print_length);
            const estWords = estimateWordsByPages(pages); // e.g. pages * 275
            if (estWords) {
                const matched = pickWordCountOptionByWords(estWords, wordCountOptions);
                if (matched) {
                    setSelectedWordCount(matched);
                    setEditAdminBook(prev => ({
                        ...prev,
                        total_words: matched.count,
                        default_price: matched.price,
                    }));
                }
            }

            toast.success('Book Data Grabbed!', { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } catch (err) {
            setKindlePriceState('');
            setPaperbackPriceState('');
            setHardcoverPriceState('');
        } finally {
            setIsLoading(false);
        }
    };

    const fetchAndFillPricesCom = async () => {
        if (grabAttempts >= 5) return;
        setGrabAttempts(x => x + 1);

        const asin = (kindleAsinState || paperbackAsinState || hardcoverAsinState || '').trim().toUpperCase();
        if (!/^[A-Z0-9]{10}$/.test(asin)) {
            setKindlePriceState('');
            setPaperbackPriceState('');
            setHardcoverPriceState('');
            return;
        }

        const url = `https://www.amazon.com/dp/${asin}`;

        try {
            setIsLoading(true);

            const data = await getFullBookDataUrlApi(url);
            setFullGrabbedData(data || {});

            const lang = resolveLanguage(data?.language, book.languages);
            if (lang) {
                book.setSelectedLanguage(lang);
                setEditAdminBook(prev => ({ ...prev, language: lang.language }));
            }

            const genre = resolveGenre(data?.categories_path, data?.categories, book.genres);
            if (genre) {
                book.setSelectedGenre(genre);
            }

            // titles / authors
            setTitleState(data?.title || '');
            setSubTitleState(data?.subtitle || '');
            setAuthorState(
                (data?.authors_str && data.authors_str.trim?.()) ||
                (Array.isArray(data?.authors) ? data.authors.join(', ') : '') ||
                ''
            );

            // descriptions
            setSummaryState(data?.description_first10 || '');
            setEditAdminBook(prev => ({ ...prev, description_full: data?.description_full || '' }));

            // flags
            setEditAdminBook(prev => ({
                ...prev,
                kindle_flag: !!data?.kindle,
                kindle_unlimited_flag: !!data?.kindle_unlimited,
                paper_back_flag: !!data?.pb,
                hard_cover_flag: !!data?.hc,
                audio_flag: !!data?.audio,
                audio_exclusive_flag: !!data?.audio,   // default: exclusive=true
                audio_non_exclusive_flag: false,
            }));

            // ASINs
            setKindleAsinState(data?.kindle_asin || '');
            setPaperBackAsinState(data?.pb_asin || '');
            setHardCoverAsinState(data?.hc_asin || '');
            setAudioAsinState(data?.audio_asin || '');
            setAudibleAsinState(data?.audio_audible_asin || data?.audible_asin || '');

            // prices
            setKindlePriceState(
                Number.isFinite(data?.prices?.kindle?.value) ? String(data.prices.kindle.value) : ''
            );
            setPaperbackPriceState(
                Number.isFinite(data?.prices?.paperback?.value) ? String(data.prices.paperback.value) : ''
            );
            setHardcoverPriceState(
                Number.isFinite(data?.prices?.hardcover?.value) ? String(data.prices.hardcover.value) : ''
            );

            // cover (prefer large → medium → HowItWorks → images[0])
            await downloadAndSetCover(
                data?.image_large ||
                data?.image_medium ||
                data?.main_image ||
                (Array.isArray(data?.images) ? data.images[0] : '')
            );

            // word count & price from print_length
            const pages = Number(data?.print_length);
            const estWords = estimateWordsByPages(pages); // e.g. pages * 275
            if (estWords) {
                const matched = pickWordCountOptionByWords(estWords, wordCountOptions);
                if (matched) {
                    setSelectedWordCount(matched);
                    setEditAdminBook(prev => ({
                        ...prev,
                        total_words: matched.count,
                        default_price: matched.price,
                    }));
                }
            }

            toast.success('Book Data Grabbed!', { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } catch (err) {
            setKindlePriceState('');
            setPaperbackPriceState('');
            setHardcoverPriceState('');
        } finally {
            setIsLoading(false);
        }
    };



    return (
        <>
        <DownloadProgressModal
            show={downloadModal.show}
            progress={downloadModal.progress}
            status={downloadModal.status}
        />
        <Modal
            show={show}
            onHide={internalHandleClose}
            backdrop="static"
            keyboard={false}
            className="modal-xl"
            id="staticBackdrop"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
        >
            <div className="modal-content small">
                <Modal.Header closeButton>
                    <div className="d-flex align-items-center justify-content-between gap-3 w-100">
                    <Modal.Title className="fs-6 mb-0">Edit Book ID: {bookData.id}, Status: {status}</Modal.Title>
                    <div className="d-flex flex-wrap gap-2 ms-auto me-3 justify-content-end">
                        <Button
                            type="button"
                            variant="outline-success"
                            size="sm"
                            onClick={() => closeAndOpenSearch(onOpenUserBooks, bookOwner?.userId || bookData?.userId)}
                        >
                            Other User Books
                        </Button>
                        <Button
                            type="button"
                            variant="outline-success"
                            size="sm"
                            onClick={() => closeAndOpenSearch(onOpenBookAssignments, bookData?.id)}
                        >
                            Book Assignments
                        </Button>
                        <Button
                            type="button"
                            variant="outline-success"
                            size="sm"
                            onClick={() => closeAndOpenSearch(onOpenUserAuthorAssignments, bookOwner?.userId || bookData?.userId)}
                        >
                            Author Assignments
                        </Button>
                        <Button
                            type="button"
                            variant="outline-success"
                            size="sm"
                            onClick={() => closeAndOpenSearch(onOpenUserReviewerAssignments, bookOwner?.userId || bookData?.userId)}
                        >
                            Author Reviews
                        </Button>
                    </div>
                    </div>
                </Modal.Header>
                <Col className="m-lg-1 d-flex">
                    <div className="modal-body">
                        <Card className="border border-secondary mb-3 ms-2 me-2">
                            <Card.Body className="py-2 ">
                                <div className="d-flex align-items-center justify-content-between gap-2">
                                <div className="d-flex flex-wrap align-items-center gap-1 flex-grow-1">

                                    {ownerLoading && <span className="text-muted">loading…</span>}

                                    {!ownerLoading && bookOwner && (
                                        <>
            ID: <span className="fw-semibold">{bookOwner.userId || "—"} /</span>
            <span className="fw-semibold"> {bookOwner.username || "—"} /</span>
            <span className="fw-semibold">{bookOwner.email || "—"} /</span>
            AMZ: <span className="fw-semibold">{bookOwner.amz_name || "—"} | {bookOwner.audible_name || "—"} /</span>
            Plan: <span className="fw-semibold">{bookOwner.tariff_plan || "—"} /</span>
            Balance: <span className="fw-semibold">{bookOwner.balance ?? "—"} Virt | ${bookOwner.lr_balance ?? "0.00"} /</span>
            Trust: <span className="fw-semibold">{bookOwner.level_of_trust ?? "—"} /</span>
            Country: <span className="fw-semibold ms-1">{hostFromUrl(bookOwner.amz_country) || "—"} | {hostFromUrl(bookOwner.audible_country) || "—"} /</span>
            This User: <span className="fw-semibold"> Post: {bookOwner.postedAss ?? "—"} | Took: {bookOwner.compiledAss ?? "—"} Assignments /</span>

                                            Registered: <span className="fw-semibold ms-1">{formatTime(bookOwner.registration_date*60) || "—"}</span>
                                        </>
                                    )}

                                    {!ownerLoading && !bookOwner && (
                                        <span className="text-muted">No user info</span>
                                    )}
                                </div>
                                    <div className="d-flex align-items-end gap-2">
                                        <Form.Group style={{ width: 96 }}>
                                            <Form.Label className="small mb-1">Owner ID</Form.Label>
                                            <Form.Control
                                                type="number"
                                                size="sm"
                                                className="border-secondary"
                                                value={bookOwnerId}
                                                onChange={(e) => setBookOwnerId(e.target.value)}
                                            />
                                        </Form.Group>
                                    {!ownerLoading && bookOwner && (
                                        <Button
                                            type="button"
                                            variant={showOwnerEditor ? "success" : "outline-success"}
                                            size="sm"
                                            className="text-nowrap"
                                            onClick={() => setShowOwnerEditor((v) => !v)}
                                        >
                                            {showOwnerEditor ? "Hide User Edit" : "User Edit"}
                                        </Button>
                                    )}
                                        {canResolveDuplicate && (
                                            <Button
                                                type="button"
                                                variant="outline-danger"
                                                size="sm"
                                                className="text-nowrap"
                                                onClick={handleResolveDuplicate}
                                                disabled={loading}
                                                title="Marks the newer duplicate as DELETED and moves the older book to the newer owner."
                                            >
                                                Remove Duplicate
                                            </Button>
                                        )}
                                    </div>
                                </div>
                                {canResolveDuplicate && (
                                    <div className="small text-muted mt-1">
                                        Remove Duplicate marks the higher book ID as DELETED and assigns the older book to that newer book owner.
                                    </div>
                                )}
                                {showOwnerEditor && bookOwner && (
                                    <div className="border-top mt-2 pt-2">
                                             <Row className="g-2 align-items-end">
                                                <Col xs={12} md={2}>
                                                    <Form.Label className="small mb-1">Amazon Reviewer</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        size="sm"
                                                        className="border-secondary"
                                                        value={ownerAmazonName}
                                                        onChange={(e) => setOwnerAmazonName(e.target.value)}
                                                    />
                                                </Col>
                                                <Col xs={12} md={2}>
                                                    <Form.Label className="small mb-1">Amazon Site</Form.Label>
                                                    <Form.Select
                                                        size="sm"
                                                        className="border-secondary"
                                                        value={ownerAmazonSite}
                                                        onChange={(e) => setOwnerAmazonSite(e.target.value)}
                                                    >
                                                        <option value="" disabled>Amazon Site</option>
                                                        {amazonSites.map((site) => (
                                                            <option key={site.code} value={site.url}>{site.label}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Col>
                                                <Col xs={12} md={1}>
                                                    <Form.Label className="small mb-1">RN Attempts</Form.Label>
                                                    <Form.Select
                                                        size="sm"
                                                        className="border-secondary"
                                                        value={ownerAmazonAttempts}
                                                        onChange={(e) => setOwnerAmazonAttempts(Number(e.target.value))}
                                                    >
                                                        {[0, 1, 2, 3].map((num) => (
                                                            <option key={num} value={num}>{num}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Col>
                                                <Col xs={12} md={1}>
                                                    <Form.Label className="small mb-1">Plan</Form.Label>
                                                    <Form.Select
                                                        size="sm"
                                                        className="border-secondary"
                                                        value={ownerTariffPlan}
                                                        onChange={(e) => setOwnerTariffPlan(e.target.value)}
                                                    >
                                                        <option value="" disabled>Plan</option>
                                                        {userStatusOptions.map((item) => (
                                                            <option key={item} value={item}>{item}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Col>
                                                <Col xs={12} md={1}>
                                                    <Form.Label className="small mb-1">Audible Rw</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        size="sm"
                                                        className="border-secondary"
                                                        value={ownerAudibleName}
                                                        onChange={(e) => setOwnerAudibleName(e.target.value)}
                                                    />
                                                </Col>
                                                <Col xs={12} md={2}>
                                                    <Form.Label className="small mb-1">Audible Site</Form.Label>
                                                    <Form.Select
                                                        size="sm"
                                                        className="border-secondary"
                                                        value={ownerAudibleSite}
                                                        onChange={(e) => setOwnerAudibleSite(e.target.value)}
                                                    >
                                                        <option value="" disabled>Audible Site</option>
                                                        {audibleSites.map((site) => (
                                                            <option key={site.code} value={site.url}>{site.label}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Col>
                                                <Col xs={12} md={1}>
                                                    <Form.Label className="small mb-1">RN Attempts</Form.Label>
                                                    <Form.Select
                                                        size="sm"
                                                        className="border-secondary"
                                                        value={ownerAudibleAttempts}
                                                        onChange={(e) => setOwnerAudibleAttempts(Number(e.target.value))}
                                                    >
                                                        {[0, 1, 2, 3].map((num) => (
                                                            <option key={num} value={num}>{num}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Col>
                                                <Col xs={12} md={2} className="d-flex justify-content-md-end">
                                                    <Button
                                                        type="button"
                                                        variant="outline-success"
                                                        size="sm"
                                                        className="text-nowrap"
                                                        onClick={saveOwnerProfileChanges}
                                                    >
                                                        Apply Changes
                                                    </Button>
                                                </Col>
                                                <Col xs={12} className="small text-muted text-nowrap overflow-auto">
                                                    User ID: <span className="fw-semibold">{bookOwner.userId}</span>, AN: <span className="fw-semibold">{bookOwner.amz_name || "—"}</span>
                                                    {" | "}
                                                    Virt: <span className="fw-semibold">{Number(parseFloat(bookOwner.balance) || 0).toFixed(0)}</span>,
                                                    USD: <span className="fw-semibold"> ${Number(parseFloat(bookOwner.lr_balance) || 0).toFixed(2)}</span>,
                                                    Trust: <span className="fw-semibold"> {bookOwner.level_of_trust ?? "—"}</span>,
                                                    Aff: <span className="fw-semibold"> ${Number(parseFloat(bookOwner.affiliate_balance) || 0).toFixed(2)}</span>
                                                </Col>
                                            </Row>

                                            <Row className="g-2 align-items-end mt-1">
                                                <Col xs={6} md={1}>
                                                    <Form.Label className="small mb-1">Virt</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        size="sm"
                                                        value={ownerVirtAmount}
                                                        onChange={(e) => setOwnerVirtAmount(e.target.value)}
                                                    />
                                                </Col>
                                                <Col xs={6} md={1}>
                                                    <Form.Label className="small mb-1">Trust</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        size="sm"
                                                        value={ownerTrustAmount}
                                                        onChange={(e) => setOwnerTrustAmount(e.target.value)}
                                                    />
                                                </Col>
                                                <Col xs={6} md={1}>
                                                    <Form.Label className="small mb-1">USD</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        size="sm"
                                                        value={ownerUsdAmount}
                                                        onChange={(e) => setOwnerUsdAmount(e.target.value)}
                                                    />
                                                </Col>
                                                <Col xs={6} md={1}>
                                                    <Form.Label className="small mb-1">Aff USD</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        size="sm"
                                                        value={ownerAffAmount}
                                                        onChange={(e) => setOwnerAffAmount(e.target.value)}
                                                    />
                                                </Col>
                                                <Col xs={12} md={6}>
                                                    <Form.Label className="small mb-1">Message</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        size="sm"
                                                        value={ownerBalanceMessage}
                                                        onChange={(e) => setOwnerBalanceMessage(e.target.value)}
                                                    />
                                                </Col>
                                                <Col xs={12} md={2} className="d-flex justify-content-md-end">
                                                    <Button
                                                        type="button"
                                                        variant="outline-success"
                                                        size="sm"
                                                        onClick={saveOwnerBalanceChanges}
                                                    >
                                                        Apply Changes
                                                    </Button>
                                                </Col>
                                            </Row>
                                    </div>
                                )}
                            </Card.Body>
                        </Card>
                        <Form>
                            <Row className="mb-2 p-2 gy-2">
                                <Col xs={12} md={5}>
                                    <label className="d-block mb-0">Edit Book Title:</label>
                                    <Form.Control
                                        className=" border border-secondary"
                                        size="sm"
                                        type="text"
                                        value={titleState}
                                        onChange={e => setTitleState(e.target.value)}
                                        placeholder="Book Title"
                                    />
                                </Col>
                                <Col xs={12} md={5}>
                                    <label className="d-block mb-0">Edit Book Subtitle:</label>
                                    <Form.Control
                                        className=" border border-secondary"
                                        size="sm"
                                        type="text"
                                        value={subtitleState}
                                        onChange={e => setSubTitleState(e.target.value)}
                                        placeholder="Book Subtitle"
                                    />
                                </Col>
                                {/* Author Name */}
                                <Col xs={12} md={2}>
                                    <label className="d-block mb-0">Edit Author Name:</label>
                                    <Form.Control
                                        size="sm"
                                        className="border border-secondary"
                                        value={authorState}
                                        onChange={e => setAuthorState(e.target.value)}
                                        placeholder="Author Name"
                                    />
                                </Col>
                            </Row>



                            <Row className="mb-1 p-1 gap-2 gap-md-0">


                                {/* Language Dropdown */}
                                <Col xs={12} md={2}>
                                    <label className="d-block mb-0">Language:</label>
                                    <Dropdown>
                                        <Dropdown.Toggle
                                            variant=""
                                            size="sm"
                                            className="w-100 text-start border border-secondary text-muted"
                                        >
                                            {
                                                book.selectedLanguage?.language ||
                                                (book.languages.length > 0
                                                    ? book.languages.find(lang => lang.id === bookData?.booksLanguageId)?.language
                                                    : "Loading...")
                                            }
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto" }}>
                                            {book.languages.map(lang => (
                                                <Dropdown.Item
                                                    onClick={() => book.setSelectedLanguage(lang)}
                                                    key={lang.id}
                                                    className="small text-muted"
                                                >
                                                    {lang.language}
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Col>

                                {/* Genre Dropdown */}
                                <Col xs={12} md={3}>
                                    <label className="d-block mb-0">Genre of Book:</label>
                                    <Dropdown>
                                        <Dropdown.Toggle
                                            variant=""
                                            size="sm"
                                            className="w-100 text-start border border-secondary text-muted"
                                        >
                                            {book.selectedGenre?.genre || "Select Genre"}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto" }}>
                                            {book.genres.map(gen => (
                                                <Dropdown.Item
                                                    onClick={() => book.setSelectedGenre(gen)}
                                                    key={gen.id}
                                                    className="small text-muted"
                                                >
                                                    {gen.genre}
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Col>
                                <Col xs={12} md={2} >
                                    <div className="flex-grow-1">
                                        <label className="d-block mb-0">Edit Word Count:</label>
                                        <Dropdown>
                                            <Dropdown.Toggle
                                                variant=""
                                                size="sm"
                                                className="w-100 text-start border border-secondary text-muted"
                                                style={{
                                                    background: 'none',
                                                    border: '1px solid #ced4da',
                                                    color: '#6c757d',
                                                    textAlign: 'left',
                                                }}
                                            >
                                                {selectedWordCount?.label || "Choose Word Count..."}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto" }}>
                                                {wordCountOptions.map(option => (
                                                    <Dropdown.Item
                                                        key={option.id}
                                                        onClick={() => handleWordCountSelect(option)}
                                                        className="small text-muted"
                                                    >
                                                        {option.label}
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>

                                </Col>
                                <Col xs={12} md={2}>
                                    <div className="d-flex flex-column align-items-start">
                                        <label className="d-block mb-0">Price:</label>
                                        <Form.Control size="sm" className="border border-secondary" value={editAdminBook.default_price} onChange={e => setEditAdminBook(prev => ({ ...prev, default_price: e.target.value }))} placeholder="Enter default price" />

                                    </div>
                                </Col>

                                {/* Status Dropdown */}
                                <Col xs={12} md={2}>
                                    <label className="d-block mb-0">Set New Status:</label>
                                    <Dropdown onSelect={(key) => setStatusSafe(key)}>
                                        <Dropdown.Toggle
                                            variant=""
                                            size="sm"
                                            className="w-100 text-start border border-secondary text-muted"
                                        >
                                            {status || "Select Status"}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {statusOptions.map(option => (
                                                <Dropdown.Item key={option} eventKey={option} className="small text-muted">
                                                    {option}
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Col>

                                {/* Go Live Button */}
                                <Col xs={12} md={1} className="d-flex align-items-end mt-2">
                                    <Button
                                        variant="danger"
                                        size="sm"
                                        className="w-100"
                                        onClick={handleUpdateBook}
                                        disabled={loading}
                                    >
                                        {loading ? <Spinner animation="border" size="sm" /> : <strong>Update</strong>}
                                    </Button>
                                </Col>
                            </Row>



                            <Row className="mb-3 p-2 gy-3 gx-2">
                                {/* Колонка: типы книги */}
                                <Col xs={12} md={4} className="d-flex flex-column">
                                    <label className="d-block mb-1">Select the Available Types for this Book:</label>

                                    <Form.Check
                                        type="checkbox"
                                        id="kindle_flag"
                                        name="kindle_flag"
                                        className="mb-1"
                                        label={
                                            <span className="small">
      {`This Book is Available in Kindle Version${priceSuffix(bookData?.kindle_price_on_amazon)}`}
    </span>
                                        }
                                        checked={Boolean(editAdminBook?.kindle_flag)}
                                        onChange={handleCheckboxChange}
                                    />

                                    <Form.Check
                                        type="checkbox"
                                        id="paper_back_flag"
                                        name="paper_back_flag"
                                        className="mb-1"
                                        label={
                                            <span className="small">
      {`This Book is Available in Paperback${priceSuffix(
          bookData?.paper_back_price_on_amazon ?? bookData?.paper_back_price_on_amazon)}`}
    </span>
                                        }
                                        checked={Boolean(editAdminBook?.paper_back_flag)}
                                        onChange={handleCheckboxChange}
                                    />

                                    <Form.Check
                                        type="checkbox"
                                        id="hard_cover_flag"
                                        name="hard_cover_flag"
                                        className="mb-1"
                                        label={
                                            <span className="small">
      {`This Book is Available in Hardcover${priceSuffix(
          bookData?.hard_cover_price_on_amazon ?? bookData?.hard_cover_price_on_amazon
      )}`}
    </span>
                                        }
                                        checked={Boolean(editAdminBook?.hard_cover_flag)}
                                        onChange={handleCheckboxChange}
                                    />
                                    <Form.Check size="sm" className="mb-1" label={
                                        <span className="small">
        {`This Book is Available in Audio Format${priceSuffix(
            bookData?.audio_price_on_amazon ?? bookData?.audio_price_on_amazon
        )}`}
    </span>
                                    }
                                        name="audio_flag" checked={editAdminBook.audio_flag} onChange={handleCheckboxChange} />
                                </Col>
                                        <Col xs={12} md={3} className="d-flex flex-column">

                                        {editAdminBook.kindle_flag && (
                                            <>
                                                <label className="d-block mb-1">Kindle Unlimited Option?</label>
                                                <Form.Check size="sm" className=" mb-1" label={
                                                    <span className="small">
        {`Yes, it's Kindle Unlimited!`}
    </span>
                                                }
                                                            name="kindle_unlimited_flag" checked={editAdminBook.kindle_unlimited_flag} onChange={handleCheckboxChange} />
                                            </>
                                        )}

                                        {editAdminBook.audio_flag && (
                                            <>
                                                <label className="d-block mb-1">Type of Audio Distribution?</label>
                                                <Form.Check size="sm" className=" mb-1" label={
                                                    <span className="small">
        {`Exclusive Distribution`}
    </span>
                                                } name="audio_exclusive_flag" checked={editAdminBook.audio_exclusive_flag} onChange={handleCheckboxChange} />
                                                <Form.Check size="sm" className=" mb-1" label={
                                                    <span className="small">
        {`Non-Exclusive Distribution`}
    </span>
                                                } name="audio_non_exclusive_flag" checked={editAdminBook.audio_non_exclusive_flag} onChange={handleCheckboxChange} />
                                            </>
                                        )}


                                </Col>

                                {/* Колонка: сообщение и файлы */}
                                <Col xs={12} md={5}>
                                    <div
                                        className="w-100"
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "minmax(0, 1fr) 230px",
                                            columnGap: 12,
                                            rowGap: 6,
                                            alignItems: "end",
                                        }}
                                    >
                                        <div className="d-flex flex-column align-items-start" style={{ minWidth: 0 }}>
                                            <label className="d-block mb-1">Message from Staff:</label>
                                            <Form.Control
                                                size="sm"
                                                className="border border-secondary rounded"
                                                value={editAdminBook.message}
                                                onChange={e => setEditAdminBook(prev => ({ ...prev, message: e.target.value }))}
                                                placeholder="Message"
                                            />
                                        </div>
                                        <div className="d-flex flex-column align-items-start">
                                            <label className="d-block mb-1 text-muted fw-semibold" style={{ whiteSpace: "nowrap" }}>
                                                {manuscriptSizeLabel}
                                            </label>
                                            <Button
                                                type="button"
                                                size="sm"
                                                variant="outline-success"
                                                className="text-nowrap w-100"
                                                onClick={handleManuscriptDownload}
                                                disabled={!hasManuscriptFile}
                                            >
                                                Download Manuscript
                                            </Button>
                                        </div>
                                        <div className="d-flex flex-column align-items-start" style={{ minWidth: 0 }}>
                                            <label className="d-block mb-1">Territories:</label>
                                            <Form.Select
                                                size="sm"
                                                className="border border-secondary text-muted"
                                                value={territoriesMode}
                                                onChange={(e) => {
                                                    const v = e.target.value;
                                                    setTerritoriesMode(v);

                                                    if (v === "WORLDWIDE") {
                                                        setAvailableMarketplaces([]);
                                                        setShowMarketplaces(false);
                                                    } else {
                                                        setShowMarketplaces(true);
                                                    }
                                                }}
                                                style={{ width: "100%" }}
                                            >
                                                <option value="WORLDWIDE">Worldwide</option>
                                                <option value="MARKETPLACES">Custom marketplaces</option>
                                            </Form.Select>
                                        </div>
                                        <div className="d-flex flex-column align-items-start">
                                            <label className="d-block mb-1 text-muted fw-semibold" style={{ whiteSpace: "nowrap" }}>
                                                Attempts: {marketplaceCheckAttempts}/3
                                            </label>
                                            <Button
                                                size="sm"
                                                variant="outline-success"
                                                onClick={checkAmazonMarketplaces}
                                                disabled={checkingMarketplaces || marketplaceCheckAttempts >= 3}
                                                className="w-100"
                                                style={{ whiteSpace: "nowrap" }}
                                            >
                                                {checkingMarketplaces ? (
                                                    <>
                                                        <Spinner animation="border" size="sm" className="me-1" />
                                                        Checking
                                                    </>
                                                ) : marketplaceCheckAttempts >= 3 ? (
                                                    "Limit Reached"
                                                ) : (
                                                    "Check Availability"
                                                )}
                                            </Button>
                                        </div>

                                        {territoriesMode === "MARKETPLACES" && (
                                            <div className="d-flex justify-content-end" style={{ gridColumn: "1 / -1" }}>
                                                <Button
                                                    size="sm"
                                                    variant="outline-secondary"
                                                    onClick={() => setShowMarketplaces((s) => !s)}
                                                    disabled={checkingMarketplaces}
                                                >
                                                    {showMarketplaces ? "Hide" : "Show"}
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                    <Col xs={12} md={12}>

                                        {territoriesMode === "MARKETPLACES" && (
                                            <div className="small mt-2">
                                                {availableMarketplaces.length === 0 ? (
                                                    <span className="text-danger fw-semibold">
                                                        Pick at least one Amazon Marketplace
                                                    </span>
                                                ) : (
                                                    <span className="text-muted">
                                                        Available on:{" "}
                                                        {availableMarketplaces.map((code, index) => {
                                                            const marketplace = MARKETPLACE_OPTIONS.find((m) => m.code === code);
                                                            return (
                                                                <React.Fragment key={code}>
                                                                    {index > 0 ? ", " : ""}
                                                                    {marketplace ? renderMarketplaceLink(marketplace, `.${code}`) : `.${code}`}
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                        {" "}(<b>{availableMarketplaces.length}</b> total)
                                                    </span>
                                                )}
                                            </div>
                                        )}

                                        {/* ROW 2: checklist UNDER the dropdown */}
                                        {territoriesMode === "MARKETPLACES" && showMarketplaces && (
                                            <div className="mt-2 border rounded p-2">
                                                <div
                                                    className="d-grid gap-1"
                                                    style={{
                                                        gridTemplateColumns: "repeat(2, minmax(160px, 1fr))",
                                                        maxHeight: 160,
                                                        overflowY: "auto",
                                                    }}
                                                >
                                                    {MARKETPLACE_OPTIONS.map((m) => (
                                                        <Form.Check
                                                            key={m.code}
                                                            type="checkbox"
                                                            className="small text-muted mb-0"
                                                            label={renderMarketplaceLink(m)}
                                                            checked={availableMarketplaces.includes(m.code)}
                                                            disabled={checkingMarketplaces}
                                                            onChange={(e) => {
                                                                const checked = e.target.checked;
                                                                setAvailableMarketplaces((prev) =>
                                                                    checked
                                                                        ? Array.from(new Set([...prev, m.code]))
                                                                        : prev.filter((x) => x !== m.code)
                                                                );
                                                            }}
                                                        />
                                                    ))}
                                                </div>

                                                <div className="d-flex justify-content-end gap-2 mt-2">
                                                    <Button
                                                        size="sm"
                                                        variant="outline-secondary"
                                                        onClick={() => setAvailableMarketplaces([])}
                                                    >
                                                        Clear
                                                    </Button>

                                                    <Button
                                                        size="sm"
                                                        variant="success"
                                                        onClick={() => {
                                                            if (availableMarketplaces.length === 0) return;
                                                            setShowMarketplaces(false);
                                                        }}
                                                        disabled={availableMarketplaces.length === 0}
                                                        title={availableMarketplaces.length === 0 ? "Pick at least one marketplace" : ""}
                                                    >
                                                        Done
                                                    </Button>
                                                </div>
                                            </div>
                                        )}
                                    </Col>


                                </Col>




                            </Row>

                            <Row w={100}>

                                <Col xs={12} md={4}>
                                    <Row className="mb-1">
                                        {coverPreview && (
                                            <div className="text-center mb-1 mt-0 ">
                                                {showEditor ? (
                                                    <>
                                                    <div ref={parentRef} style={{ width: "90%", maxWidth: "500px", margin: "auto" }} className="mt-0">


                                                            <AvatarEditor
                                                                ref={(ref) => setEditorRef(ref)}
                                                                image={coverPreview}
                                                                width={editorSize.width}
                                                                height={editorSize.height}
                                                                border={0}
                                                                scale={scale}
                                                                borderRadius={0}
                                                                className="text-center mb-0 mt-0 me-5 m-auto rounded"
                                                            />
                                                            <input
                                                                type="range"
                                                                min="1"
                                                                max="2"
                                                                step="0.005"
                                                                value={scale}
                                                                onChange={(e) => setScale(parseFloat(e.target.value))}
                                                                className="form-range mt-2"
                                                                style={{width: '100px'}}  // Устанавливаем ширину в 300px
                                                            />
                                                            <Row className="d-flex align-items-center justify-content-between mt-2">
                                                                {/* Выбор формата книги */}
                                                                <select
                                                                    value={bookFormat}
                                                                    onChange={(e) => setBookFormat(e.target.value)}
                                                                    className="form-select w-auto"
                                                                    style={{minWidth: "120px"}}  // Чтоб select не сжимался слишком сильно
                                                                >
                                                                    <option value="6x9">Format: 6x9</option>
                                                                    <option value="8.5x11">Format: 8.5x11</option>
                                                                    <option value="8x10">Format: 8x10</option>

                                                                    <option value="5x8">Format: 5x8</option>
                                                                    <option value="7x10">Format: 7x10</option>
                                                                </select>

                                                                {/* Кнопка */}
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success w-auto"
                                                                    onClick={handleSave}
                                                                >
                                                                    Save Cover
                                                                </button>


                                                            </Row>

                                                        </div>


                                                    </>
                                                ) : (


                                                    <img src={coverPreview}
                                                         alt="Cover Preview"
                                                         style={{objectFit: 'cover', borderRadius: '8px'}}
                                                         width={200}
                                                         className="img-fluid"/>
                                                )}

                                            </div>
                                        )}
                                        <div className="d-flex justify-content-center mb-1 mt-1">
                                            <button
                                                type="button"

                                                className="btn btn-primary btn-success btn-sm flex-md-row me-2 "
                                                onClick={triggerFileInput}
                                                disabled={loading}
                                            >
                                                Upload
                                            </button>

                                            <input
                                                type="file"
                                                id="fileInput"
                                                style={{display: "none"}}
                                                onChange={handleFileChange}
                                            />
                                            {originalCover ? (
                                                <>
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary fflex-md-row me-2 "
                                                        onClick={handleEditOriginal}
                                                    >
                                                        Edit
                                                    </button>

                                                </>

                                            ):( "" )}

                                        </div>
                                    </Row>
                                </Col>

                                <Col xs={12} md={8}>
                                    <Row className="mb-3 p-1">
                                        <div className="mt-0">
                                            <span className="fw-semibold small  text-success">Update: </span>   <span className="fw-semibold small text-muted">{formatTime(bookData?.last_update_book_data_from_amazon_date)}</span>
                                            <span className="fw-semibold small  text-success"> | Added: </span>
                                            <span className="fw-semibold small text-muted">
    {bookData?.createdAt ? formatTime(Math.floor(new Date(bookData.createdAt).getTime() / 1000)) : "—"}
  </span>

                                            <span className="fw-semibold small text-success"> | Edit: </span>
                                            <span className="fw-semibold small text-muted">
    {bookData?.createdAt ? formatTime(Math.floor(new Date(bookData.updatedAt).getTime() / 1000)) : "—"}
  </span>
                                        </div>
                                        {/* Проверяем, есть ли что-то в первой колонке */}
                                        {(editAdminBook.paper_back_flag || editAdminBook.kindle_flag) && (
                                            <Col md={6} style={{ maxWidth: "100%" }}>

                                                {editAdminBook.kindle_flag && (
                                                    <Form className="mt-0 mb-0">
                                                        <label className="small mt-2">Kindle ASIN:</label>
                                                        <div className="d-flex align-items-center">
                                                            <Form.Control size="sm" className=" border border-secondary rounded"
                                                                value={kindleAsinState}
                                                                onChange={e => setKindleAsinState(e.target.value)}
                                                                placeholder="Enter Kindle ASIN..."
                                                                disabled={loading}
                                                            />
                                                            <Button
                                                                variant="info"
                                                                className="ms-2 btn-sm"
                                                                disabled={!kindleAsinState}
                                                                onClick={async () => {
                                                                    try {
                                                                        const targetUrl = `https://www.amazon.com/dp/${kindleAsinState}`;

                                                                        const response = await getRedirectUrlApi(targetUrl);

                                                                        if (response && response.redirectUrl) {
                                                                            window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                        } else {
                                                                            console.error('Failed to get redirect URL');
                                                                        }
                                                                    } catch (err) {
                                                                        console.error('Redirect error:', err);
                                                                    }
                                                                }}

                                                            >
                                                                Check
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                )}

                                                {editAdminBook.paper_back_flag && (
                                                    <Form className="mt-0 mb-0">
                                                        <label className="small mt-2">Paperback ASIN:</label>
                                                        <div className="d-flex align-items-center">
                                                            <Form.Control size="sm" className=" border border-secondary rounded"
                                                                value={paperbackAsinState}
                                                                onChange={e => setPaperBackAsinState(e.target.value)}
                                                                placeholder="Enter Paperback ASIN..."
                                                                disabled={loading}
                                                            />
                                                            <Button
                                                                variant="info"
                                                                className="ms-2 btn-sm"
                                                                disabled={!paperbackAsinState}
                                                                onClick={async () => {
                                                                    try {
                                                                        const targetUrl = `https://www.amazon.com/dp/${paperbackAsinState}`;

                                                                        const response = await getRedirectUrlApi(targetUrl);

                                                                        if (response && response.redirectUrl) {
                                                                            window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                        } else {
                                                                            console.error('Failed to get redirect URL');
                                                                        }
                                                                    } catch (err) {
                                                                        console.error('Redirect error:', err);
                                                                    }
                                                                }}
                                                            >
                                                                Check
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                )}

                                                {(editAdminBook.audio_non_exclusive_flag || editAdminBook.audio_exclusive_flag || editAdminBook.audio_flag) && (
                                                    <>
                                                        {(editAdminBook.audio_non_exclusive_flag || editAdminBook.audio_exclusive_flag) && (
                                                            <Form className="mt-0 mb-3">
                                                                <label className="small mt-2">Audible ASIN:</label>
                                                                <div className="d-flex align-items-center">
                                                                    <Form.Control size="sm" className=" border border-secondary rounded"
                                                                        value={audibleAsinState}
                                                                        onChange={e => setAudibleAsinState(e.target.value)}
                                                                        placeholder="Enter Audible ASIN..."
                                                                        disabled={loading}
                                                                    />
                                                                    <Button
                                                                        variant="info"
                                                                        className="ms-2 btn-sm"
                                                                        disabled={!audibleAsinState}
                                                                        onClick={async () => {
                                                                            try {
                                                                                const targetUrl = `https://www.audible.com/pd/${audibleAsinState}`;

                                                                                const response = await getRedirectUrlApi(targetUrl);

                                                                                if (response && response.redirectUrl) {
                                                                                    window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                                } else {
                                                                                    console.error('Failed to get redirect URL');
                                                                                }
                                                                            } catch (err) {
                                                                                console.error('Redirect error:', err);
                                                                            }
                                                                        }}
                                                                    >
                                                                        Check
                                                                    </Button>
                                                                </div>
                                                            </Form>
                                                        )}
                                                    </>
                                                )}


                                            </Col>
                                        )}

                                        {/* Если первая колонка есть → вторая md=6, иначе md="auto" */}
                                        <Col md={editAdminBook.paper_back_flag || editAdminBook.kindle_flag ? 6 : 8} style={{ maxWidth: "50%" }}>
                                            {editAdminBook.hard_cover_flag && (
                                                <Form className="mt-0 mb-1">
                                                    <label className="small mt-2">Hardcover ASIN:</label>
                                                    <div className="d-flex align-items-center">
                                                        <Form.Control size="sm" className=" border border-secondary rounded"
                                                            value={hardcoverAsinState}
                                                            onChange={e => setHardCoverAsinState(e.target.value)}
                                                            placeholder="Enter Hardcover ASIN..."
                                                            disabled={loading}
                                                        />
                                                        <Button
                                                            variant="info"
                                                            className="ms-2 btn-sm"
                                                            disabled={!hardcoverAsinState}
                                                            onClick={async () => {
                                                                try {
                                                                    const targetUrl = `https://www.amazon.com/dp/${hardcoverAsinState}`;

                                                                    const response = await getRedirectUrlApi(targetUrl);

                                                                    if (response && response.redirectUrl) {
                                                                        window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                    } else {
                                                                        console.error('Failed to get redirect URL');
                                                                    }
                                                                } catch (err) {
                                                                    console.error('Redirect error:', err);
                                                                }
                                                            }}
                                                        >
                                                            Check
                                                        </Button>
                                                    </div>
                                                </Form>
                                            )}

                                            {editAdminBook.audio_flag && (
                                                <Form className="mt-0 mb-3">
                                                    <label className="small mt-2">Amazon Audio ASIN:</label>
                                                    <div className="d-flex align-items-center">
                                                        <Form.Control size="sm" className=" border border-secondary rounded"
                                                            value={audioAsinState}
                                                            onChange={e => setAudioAsinState(e.target.value)}
                                                            placeholder="Enter Amazon Audio ASIN..."
                                                            disabled={loading}
                                                        />
                                                        <Button
                                                            variant="info"
                                                            className="ms-2 btn-sm"
                                                            disabled={!audioAsinState}
                                                            onClick={async () => {
                                                                try {
                                                                    const targetUrl = `https://www.amazon.com/dp/${audioAsinState}`;

                                                                    const response = await getRedirectUrlApi(targetUrl);

                                                                    if (response && response.redirectUrl) {
                                                                        window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                    } else {
                                                                        console.error('Failed to get redirect URL');
                                                                    }
                                                                } catch (err) {
                                                                    console.error('Redirect error:', err);
                                                                }
                                                            }}
                                                        >
                                                            Check
                                                        </Button>
                                                    </div>
                                                </Form>
                                            )}
                                        </Col>
                                        <Row>
                                            {editAdminBook.audio_non_exclusive_flag && (
                                                <Form className="mt-0 mb-3">
                                                    <div className="small lh-3">Enter Link to Your Non-Exclusive
                                                        Audio Book:
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                        <Form.Control size="sm" className=" border border-secondary rounded"
                                                            value={audioBookLinkState}
                                                            onChange={e => setAudioBookLinkState(e.target.value)}
                                                            placeholder="Enter Link to Your Non-Exclusive Audio Book... https://drive.google.com/drive/"
                                                            disabled={loading}
                                                        />
                                                        <Button
                                                            variant="info"
                                                            className="ms-2 btn-sm"
                                                            disabled={!audioBookLinkState}
                                                            onClick={() => window.open(`${audioBookLinkState}`, '_blank',  'noopener noreferrer')}
                                                        >
                                                            Check
                                                        </Button>
                                                    </div>
                                                </Form>
                                            )}
                                        </Row>
                                    </Row>

                                    {/* Book Pricing */}


                                    <Row className="mb-0 p-1">
                                        <Col md={12} style={{ maxWidth: "100%" }}>
                                            <Form className="mt-0 mb-0">
                                                {/* убрали align-items-center */}
                                                <Row className="mt-0 gap-3 justify-content-between">
                                                    {editAdminBook.kindle_flag && (
                                                        <Col xs={12} md={2}>
                                                            <label className="small mt-2">Kindle Price:</label>
                                                            <Form.Control
                                                                size="sm"
                                                                type="text"
                                                                inputMode="decimal"
                                                                pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                className="border border-secondary rounded"
                                                                placeholder="Kindle Price"
                                                                value={kindlePriceState}
                                                                onChange={(e) => setKindlePriceState(e.target.value)}
                                                                disabled={isLoading}
                                                            />
                                                        </Col>
                                                    )}

                                                    {editAdminBook.paper_back_flag && (
                                                        <Col xs={12} md={2}>
                                                            <label className="small mt-2">Paper Back Price:</label>
                                                            <Form.Control
                                                                size="sm"
                                                                type="text"
                                                                inputMode="decimal"
                                                                pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                className="border border-secondary rounded"
                                                                placeholder="Paperback Price"
                                                                value={paperbackPriceState}
                                                                onChange={(e) => setPaperbackPriceState(e.target.value)}
                                                                disabled={isLoading}
                                                            />
                                                        </Col>
                                                    )}

                                                    {editAdminBook.hard_cover_flag && (
                                                        <Col xs={12} md={2}>
                                                            <label className="small mt-2">Hard Cover Price:</label>
                                                            <Form.Control
                                                                size="sm"
                                                                type="text"
                                                                inputMode="decimal"
                                                                pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                className="border border-secondary rounded"
                                                                placeholder="Hardcover Price"
                                                                value={hardcoverPriceState}
                                                                onChange={(e) => setHardcoverPriceState(e.target.value)}
                                                                disabled={isLoading}
                                                            />
                                                        </Col>
                                                    )}

                                                    {/* Кнопка: прижали вниз */}
                                                    <Col xs={12} md={4} className="d-flex align-self-end mt-2 mt-md-0 justify-content-end gap-2">
                                                        <Button
                                                            variant="info"
                                                            size="sm"
                                                            disabled={isLoading}
                                                            onClick={fetchAndFillPrices}
                                                        >
                                                            {isLoading ? "Working.." : "Grab User"}
                                                        </Button>
                                                        <Button
                                                            variant="info"
                                                            size="sm"
                                                            disabled={isLoading}
                                                            onClick={fetchAndFillPricesCom}
                                                        >
                                                            {isLoading ? "Working.." : "Grab Com"}
                                                        </Button>
                                                        {status !== "LIVE" && (
                                                            <Button
                                                                variant="success"
                                                                size="sm"
                                                                disabled={loading || isLoading}
                                                                onClick={handleSetLive}
                                                            >
                                                                Set Live
                                                            </Button>
                                                        )}

                                                        <Button
                                                            variant="success"
                                                            size="sm"
                                                            disabled={loading || isLoading}
                                                            onClick={handleUpdateBook}
                                                        >
                                                            {loading ? "Saving…" : "Save"}
                                                        </Button>

                                                    </Col>

                                                </Row>

                                                {fullGrabbedData?.title && (


                                                <>
                                                    <div className="mt-2">
                                                        <span className="fw-semibold text-success">Title (Test): </span>   <span className="fw-semibold text-muted">{fullGrabbedData?.title}</span>
                                                    </div>
                                                    <div className="mt-0">
                                                        <span className="fw-semibold text-success small">Subtitle: </span>   <span className="small text-muted">{fullGrabbedData?.subtitle}</span>
                                                    </div>
                                                    <div className="mt-0">
                                                        <span className="fw-semibold text-success small">Author: </span>
                                                        <span className="small text-muted">
    {/* показываем authors_str, иначе первого автора из массива, иначе тире */}
                                                            {(fullGrabbedData?.authors_str || fullGrabbedData?.authors?.[0]) ?? '—'}
                                                            {/* если есть и строка, и первый автор, и они разные — добавим через | */}
                                                            {fullGrabbedData?.authors_str &&
                                                                fullGrabbedData?.authors?.[0] &&
                                                                fullGrabbedData.authors_str !== fullGrabbedData.authors[0] &&
                                                                ` | ${fullGrabbedData.authors[0]}`}
  </span>

                                                        <span className="fw-semibold text-success small ms-2">Cover Link: </span>
                                                        <span className="small text-muted">
    {/* Small */}
                                                            {fullGrabbedData?.image_small && (
                                                                <a
                                                                    href={fullGrabbedData.image_small}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    referrerPolicy="no-referrer"
                                                                >
                                                                    Cover Small
                                                                </a>
                                                            )}

                                                            {/* | между Small и Medium */}
                                                            {fullGrabbedData?.image_small && fullGrabbedData?.image_medium && ' | '}

                                                            {/* Medium */}
                                                            {fullGrabbedData?.image_medium && (
                                                                <a
                                                                    href={fullGrabbedData.image_medium}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    referrerPolicy="no-referrer"
                                                                >
                                                                    Cover Medium
                                                                </a>
                                                            )}

                                                            {/* | перед Large, если уже была хотя бы одна ссылка */}
                                                            {fullGrabbedData?.image_large &&
                                                                (fullGrabbedData?.image_small || fullGrabbedData?.image_medium) &&
                                                                ' | '}

                                                            {/* Large */}
                                                            {fullGrabbedData?.image_large && (
                                                                <a
                                                                    href={fullGrabbedData.image_large}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    referrerPolicy="no-referrer"
                                                                >
                                                                    Cover Large
                                                                </a>
                                                            )}
  </span>
                                                    </div>
                                                </>
                                                )}




                                            </Form>
                                        </Col>

                                    </Row>




                                    <Row className="mb-3 p-3">
                                        <Form.Control
                                            className="border border-secondary small text-muted"
                                            as="textarea"
                                            rows={3}
                                            value={summaryState}
                                            onChange={e => setSummaryState(e.target.value)}
                                            placeholder="Book Summary"
                                            style={{ fontSize: "0.875rem" }}
                                        />
                                    </Row>


                                    <Row className="mb-3 p-1">
                                        <label className="mx-auto p-1">
                                            ReUpload Book File (PDF up to 500 Mb):
                                        </label>

                                        {/* 🔹 Контейнер для кнопки и индикатора загрузки в одной строке */}
                                        <div className="d-flex align-items-center justify-content-between w-100">
                                            {/* 🔴 Кнопка загрузки слева */}
                                            <Button variant="danger" onClick={triggerFileInputBook} className="me-3 btn btn-sm">
                                                Upload
                                            </Button>

                                            {editAdminBook.book_download || pdfFileTitle ? (
                                                <>
                                                    {/* 🔹 Индикатор загрузки справа */}
                                                    {uploadProgress > 0 && (
                                                        <div
                                                            className="progress flex-grow-1"
                                                            role="progressbar"
                                                            aria-valuenow={uploadProgress}
                                                            aria-valuemin="0"
                                                            aria-valuemax="100"
                                                            style={{ height: "24px" }} // Увеличенная высота
                                                        >
                                                            <div
                                                                className={`progress-bar ${uploadProgress === 100 ? "bg-success" : "bg-info"}`}
                                                                style={{ width: `${uploadProgress}%` }}
                                                            >
                                                                {uploadProgress === 100
                                                                    ? <strong>Uploading {pdfFileTitle} is Complete</strong>
                                                                    : uploadProgress === 99
                                                                        ? <strong>Processing manuscript: watermarking and compressing...</strong>
                                                                        : `${uploadProgress}%`}
                                                            </div>
                                                        </div>
                                                    )}

                                                </>

                                            ):("")}

                                            {(pdfFileTitle && !uploadProgress) && (
                                                <>
                                                    <Col className="text-center shadow rounded py-1">
                                                        <span className="text-muted fst-italic d-block">Saved</span>
                                                    </Col>
                                                </>
                                            )}

                                        </div>

                                        {/* 🔹 Скрытый input для загрузки */}
                                        <Form.Group className="mb-3">
                                            <Form.Control
                                                type="file"
                                                accept="application/pdf"
                                                id="fileInputBook"
                                                onChange={selectBookFile}
                                                style={{ display: "none" }}
                                            />
                                        </Form.Group>

                                        {/* 🔹 Отображение загруженного файла */}
                                        {pdfFileTitle && (
                                            <div className="mt-1 text-muted">


                                            </div>
                                        )}

                                        {/* 🔹 Подсказка пользователю */}
                                        <div className="mt-auto d-flex justify-content-end">

                                            {(uploadProgress > 0 && uploadProgress < 100) ? (
                                                <p className="mb-1 text-muted">Processing manuscript: watermarking and compressing. Please wait...</p>
                                            ) : (uploadProgress !== 100 && !pdfFileTitle) ? (
                                                <p className="mb-1 text-muted">After Uploading Book File, You Can Send Book to Moderation!</p>
                                            ) : (
                                                <p className="mb-1 text-muted">Click "Update Book"</p>
                                            )}
                                        </div>
                                    </Row>


                                </Col>


                            </Row>

                        </Form>
                        <div className="border-top mt-2 pt-2">
                            <div className="d-flex flex-wrap gap-2 align-items-center">
                                <Button
                                    variant={bookPanelMode === "bookLogs" ? "secondary" : "outline-secondary"}
                                    size="sm"
                                    onClick={() => loadBookPanel("bookLogs")}
                                    disabled={bookPanelLoading && bookPanelMode === "bookLogs"}
                                >
                                    Book Logs
                                </Button>
                                <Button
                                    variant={bookPanelMode === "userLogs" ? "secondary" : "outline-secondary"}
                                    size="sm"
                                    onClick={() => loadBookPanel("userLogs")}
                                    disabled={bookPanelLoading && bookPanelMode === "userLogs"}
                                >
                                    User Logs
                                </Button>
                                <Button
                                    variant={bookPanelMode === "linked" ? "danger" : "outline-danger"}
                                    size="sm"
                                    onClick={() => loadBookPanel("linked")}
                                    disabled={bookPanelLoading && bookPanelMode === "linked"}
                                >
                                    Check Linked (Anti-Fraud)
                                </Button>
                                <Button
                                    variant={bookPanelMode === "assignments" ? "success" : "outline-success"}
                                    size="sm"
                                    onClick={() => loadBookPanel("assignments")}
                                    disabled={bookPanelLoading && bookPanelMode === "assignments"}
                                >
                                    Assignments
                                </Button>
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={clearBookPanel}
                                    disabled={!bookPanelMode && !bookPanelLogs.length && !bookPanelLinked && !bookPanelAssignments.length}
                                >
                                    Clear
                                </Button>
                            </div>

                            {bookPanelMode && (
                                <div className="mt-3">
                                    {bookPanelLoading ? (
                                        <div className="d-flex align-items-center gap-2 small text-muted">
                                            <Spinner animation="border" size="sm" /> Loading...
                                        </div>
                                    ) : bookPanelError ? (
                                        <div className="alert alert-light border py-2 px-3 small mb-2">
                                            {bookPanelError}
                                        </div>
                                    ) : null}

                                    {!bookPanelLoading && bookPanelLogs.length > 0 && (
                                        <div>
                                            <h6 className="mb-2">
                                                {bookPanelMode === "bookLogs" ? "Book Logs" : "User Logs"}
                                                <span className="ms-2 text-muted small">
                                                    Book ID: {bookData?.id} | User ID: {bookOwner?.userId || bookData?.userId} | Total: {bookPanelLogs.length}
                                                </span>
                                            </h6>
                                            <div style={{ overflowX: "auto", whiteSpace: "nowrap", paddingBottom: 6 }}>
                                                <Table bordered hover size="sm" striped className="mt-1" style={{ minWidth: 980 }}>
                                                    <thead className="table-light small">
                                                    <tr className="small">
                                                        <th className="small">ID</th>
                                                        <th className="small">UID</th>
                                                        <th className="small">AName</th>
                                                        <th className="small">Amount</th>
                                                        <th className="small">Balance</th>
                                                        <th className="small">Description</th>
                                                        <th className="small">Date</th>
                                                        <th className="small">Type</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {bookPanelLogs.map((log) => (
                                                        <tr key={`book-panel-log-${log.id}`} className="small">
                                                            <td className="small">{log.id}</td>
                                                            <td className="small">{log.user_id}</td>
                                                            <td className="text-nowrap small">{log.user_amz_name}</td>
                                                            <td className="small">{log.amount}</td>
                                                            <td className="small">{log.balance_state}</td>
                                                            <td className="small" title={log.description}>{shortText(log.description, 120)}</td>
                                                            <td className="align-middle text-center small text-nowrap">{formatDateCell(log.createdAt)}</td>
                                                            <td className="align-middle text-center small text-nowrap">{log.log_type}</td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </div>
                                    )}

                                    {!bookPanelLoading && bookPanelLinked && (
                                        <div>
                                            <h6 className="mb-2">
                                                Anti-Fraud Linked Accounts
                                                <span className="ms-2 text-muted small">
                                                    Source User: {bookPanelLinked.source_user_id} | Lookback: {bookPanelLinked.lookback_days} days | Total: {bookPanelLinked.total_matches}
                                                </span>
                                            </h6>
                                            {Array.isArray(bookPanelLinked.results) && bookPanelLinked.results.length > 0 && (
                                                <div style={{ overflowX: "auto", whiteSpace: "nowrap", paddingBottom: 6 }}>
                                                    <Table bordered hover size="sm" striped className="mt-1" style={{ minWidth: 920 }}>
                                                        <thead className="table-light small">
                                                        <tr className="small">
                                                            <th className="small">ID</th>
                                                            <th className="small">Username</th>
                                                            <th className="small">AMZ Name</th>
                                                            <th className="small">Matched Fields</th>
                                                            <th className="small">Counts per Field</th>
                                                            <th className="small">Hits</th>
                                                            <th className="small">First Seen</th>
                                                            <th className="small">Last Seen</th>
                                                            <th className="small">Weight</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {(bookPanelLinked.results || []).map((row, index) => {
                                                            const counts = Object.entries(row.counts_per_field || {}).map(([key, value]) => `${key}: ${value}`).join(", ");
                                                            const fields = (row.matched_fields || []).join(", ");
                                                            return (
                                                                <tr key={`linked-${row.other_user_id ?? "guest"}-${index}`} className="small">
                                                                    <td className="small">{row.other_user_id ?? "guest"}</td>
                                                                    <td className="small">{row.user?.username || "N/A"}</td>
                                                                    <td className="small">{row.user?.amz_name || "N/A"}</td>
                                                                    <td className="small" title={fields}>{shortText(fields, 38)}</td>
                                                                    <td className="small" title={counts}>{shortText(counts, 44)}</td>
                                                                    <td className="small text-center">{row.total_hits}</td>
                                                                    <td className="small text-nowrap">{formatDateCell(row.first_seen_at)}</td>
                                                                    <td className="small text-nowrap">{formatDateCell(row.last_seen_at)}</td>
                                                                    <td className="small text-end">{row.suspicion_weight}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {!bookPanelLoading && bookPanelAssignments.length > 0 && (
                                        <div>
                                            <h6 className="mb-2">
                                                Assignments for This Book
                                                <span className="ms-2 text-muted small">
                                                    Book ID: {bookData?.id} | Total: {bookPanelCount}
                                                </span>
                                            </h6>
                                            <div style={{ overflowX: "auto", whiteSpace: "nowrap", paddingBottom: 6 }}>
                                                <Table bordered hover size="sm" striped className="mt-1" style={{ minWidth: 980 }}>
                                                    <thead className="table-light small">
                                                    <tr className="small">
                                                        <th className="small">AID</th>
                                                        <th className="small">Status</th>
                                                        <th className="small">Check</th>
                                                        <th className="small">BID</th>
                                                        <th className="small">Title</th>
                                                        <th className="small">OID</th>
                                                        <th className="small">RID</th>
                                                        <th className="small">Reviewer</th>
                                                        <th className="small">Type</th>
                                                        <th className="small">Start</th>
                                                        <th className="small">Report</th>
                                                        <th className="small">Confirm</th>
                                                        <th className="small">Link</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {bookPanelAssignments.map((assignment) => {
                                                        const title = assignment.book?.title || assignment.book_title || assignment.title || bookData?.title;
                                                        const reviewerName = assignment.reviewer?.amz_name || assignment.reviewer_name;
                                                        const assType = assignment.assType?.ass_type_name || assignment.ass_type_name || assignment.assTypeId;
                                                        return (
                                                            <tr key={`book-panel-assignment-${assignment.id}`} className="small">
                                                                <td className="small">{assignment.id}</td>
                                                                <td className="small">{assignment.assignment_status || "N/A"}</td>
                                                                <td className="small">{assignment.check_status || "N/A"}</td>
                                                                <td className="small">{assignment.bookId || assignment.book?.id || bookData?.id}</td>
                                                                <td className="small" title={title}>{shortText(title, 42)}</td>
                                                                <td className="small">{assignment.userId || assignment.owner?.id || "N/A"}</td>
                                                                <td className="small">{assignment.reviewer_id || "N/A"}</td>
                                                                <td className="small" title={reviewerName}>{shortText(reviewerName, 24)}</td>
                                                                <td className="small">{assType || "N/A"}</td>
                                                                <td className="small">{formatMinutesCell(assignment.start_read_date)}</td>
                                                                <td className="small">{formatMinutesCell(assignment.publish_rev_date)}</td>
                                                                <td className="small">{formatMinutesCell(assignment.end_rev_date)}</td>
                                                                <td className="small">{assignment.review_link ? "Yes" : "No"}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </Col>

                <div className="modal-footer">
                    <Button variant="secondary" onClick={internalHandleClose} disabled={loading} className="btn btn-secondary btn-sm">Close</Button>
                    <Button variant="success" onClick={handleUpdateBook} disabled={loading || (uploadProgress > 0 && uploadProgress < 100)} className="btn btn-success btn-sm">
                        {(loading || (uploadProgress > 0 && uploadProgress < 100))
                            ? <><Spinner animation="border" size="sm" /> {uploadProgress === 99 ? "Processing Manuscript" : "Uploading File"}</>
                            : 'Update Book'}
                    </Button>
                </div>
            </div>
        </Modal>
        </>
    );
});

export default EditBookAdmin;
